// import { Injectable } from '@angular/core';
// import { environment } from 'src/environments/environment';
// import { ServerResponse } from '../models/dto/server-response.dto';
// import { RplStorageService } from 'src/app/modules/stp-operations/services/rpl-storage.service';
// import { NzNotificationService } from 'ng-zorro-antd/notification';
// import pdfMake from 'pdfmake/build/pdfmake';
// import * as pdfFonts from 'pdfmake/build/vfs_fonts';
// (pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

// @Injectable({
//   providedIn: 'root',
// })
// export class CertificateService {
//   constructor(
//     private rplStorageService: RplStorageService,
//     private notification: NzNotificationService
//   ) {}

//   // rpl batch
//   fetchDataFromTCIAndDownloadCertificateRPL(data: any) {
//     this.rplStorageService.downloadCertificateForRpl(data).subscribe({
//       next: (response: ServerResponse) => {
//         if (!response?.success) {
//           this.notification.error(
//             'Error',
//             response?.message || 'Something went wrong!'
//           );
//           return;
//         }
//         this.onCertificateDownloadRPL(response.data);
//       },
//       error: (error: any) => {
//         console.error('API Error:', error);
//         this.notification.error(
//           'Error',
//           'Certificate download failed due to missing or incomplete data. Please try again.'
//         );
//       },
//     });
//   }

//   // regular batch
//   fetchDataFromTCIAndDownloadCertificate(data: any) {
//     this.rplStorageService.downloadCertificateForRpl(data).subscribe({
//       next: (response: ServerResponse) => {
//         if (!response?.success) {
//           this.notification.error(
//             'Error',
//             response?.message || 'Something went wrong!'
//           );
//           return;
//         }
//         this.onCertificateDownloadREG(response.data);
//       },
//       error: (error: any) => {
//         console.error('API Error:', error);
//         this.notification.error(
//           'Error',
//           'Certificate download failed due to missing or incomplete data. Please try again.'
//         );
//       },
//     });
//   }

//   async onFreelancerCertificateDownload(data: any) {
//     try {
//       const bgImageBase64 = await this.getBase64ImageFromURL(
//         '/assets/certificate/new_certificate_files_by_pdf_make/bg.jpg'
//       );
//       const checkIconBase64 = await this.getBase64ImageFromURL(
//         '/assets/certificate/new_certificate_files_by_pdf_make/green-check-mark.jpeg'
//       );

//       let fileUrl = data.tciCertificateInfoPayload.chairmanSignatureFilePath;
//       let chairmanSignatureBase64 = await this.getChairmanImageBase64(fileUrl);

//       await this.loadFontToVFS('/assets/fonts/NikoshBAN.ttf', 'NikoshBAN');
//       await this.loadFontToVFS(
//         '/assets/fonts/Carattere/Carattere-Regular.ttf',
//         'Carattere-Regular'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Edwardian-Script/edwardianscriptitc.ttf',
//         'edwardianscriptitc'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Edwardian-Script/edwardian-script-itc-bold.ttf',
//         'edwardianscriptitcb'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Old-English-Text-MT/oldenglishtextmt.ttf',
//         'oldenglishtextmt'
//       );

//       await this.loadFontToVFS(
//         '/assets/fonts/Calibri/calibri-bold-italic.ttf',
//         'calibri-bold-italic'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Calibri/calibri-bold.ttf',
//         'calibri-bold'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Calibri/calibri-italic.ttf',
//         'calibri-italic'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Calibri/calibri-regular.ttf',
//         'calibri-regular'
//       );

//       (pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
//       (pdfMake as any).fonts = {
//         NikoshBAN: {
//           normal: 'NikoshBAN.ttf',
//           bold: 'NikoshBAN.ttf',
//           italics: 'NikoshBAN.ttf',
//           bolditalics: 'NikoshBAN.ttf',
//         },
//         Roboto: {
//           normal: 'Roboto-Regular.ttf',
//           bold: 'Roboto-Medium.ttf',
//           italics: 'Roboto-Italic.ttf',
//           bolditalics: 'Roboto-MediumItalic.ttf',
//         },
//         EdwardianScriptItc: {
//           normal: 'edwardianscriptitc.ttf',
//           bold: 'edwardianscriptitcb.ttf',
//           italics: 'edwardianscriptitc.ttf',
//           bolditalics: 'edwardianscriptitc.ttf',
//         },
//         Carattere: {
//           normal: 'Carattere-Regular.ttf',
//           bold: 'Carattere-Regular.ttf',
//           italics: 'Carattere-Regular.ttf',
//           bolditalics: 'Carattere-Regular.ttf',
//         },
//         OldEnglishTexTmt: {
//           normal: 'oldenglishtextmt.ttf',
//           bold: 'oldenglishtextmt.ttf',
//           italics: 'oldenglishtextmt.ttf',
//           bolditalics: 'oldenglishtextmt.ttf',
//         },
//         Calibri: {
//           normal: 'calibri-regular.ttf',
//           bold: 'calibri-bold.ttf',
//           italics: 'calibri-italic.ttf',
//           bolditalics: 'calibri-bold-italic.ttf',
//         },
//       };

//       const documentDefinition: any = {
//         pageSize: 'A4',
//         pageMargins: [40, 40, 40, 40],

//         background: [
//           {
//             image: 'bgImage',
//             width: 595,
//             height: 842,
//             absolutePosition: { x: 0, y: 0 },
//           },
//         ],

//         content: [
//           {
//             text: 'Government of the People’s Republic of Bangladesh',
//             style: 'header',
//           },
//           {
//             text: data.tciCertificateInfoPayload.officeNameEnglish,
//             style: 'subheaderGreen',
//           },
//           {
//             text: 'NATIONAL SKILLS DEVELOPMENT AUTHORITY (NSDA)',
//             style: 'subheader',
//           },
//           {
//             text: 'National Skills Certificate',
//             style: 'certificateTitle',
//           },
//           {
//             text: 'on',
//             style: 'labelOn',
//           },
//           {
//             text: data.tciCertificateInfoPayload.duration
//               ? `${data.tciCertificateInfoPayload.certificateName} (${data.tciCertificateInfoPayload.duration} hours)`
//               : data.tciCertificateInfoPayload.certificateName,
//             style: 'courseTitle',
//           },
//           {
//             text: '[Under the Bangladesh National Qualification Framework (BNQF)]',
//             style: 'bnqfHeader',
//           },
//           {
//             text: 'is awarded to',
//             style: 'labelIsAwardedTo',
//           },
//           {
//             text: data.tciCertificateInfoPayload.participantName,
//             style: 'participantName',
//           },

//           {
//             text: [
//               `Father's Name: `,
//               {
//                 text: data.tciCertificateInfoPayload.fatherNameEnglish,
//                 style: 'fatherMotherNidDynamicValue',
//               },
//               `, Mother's Name: `,
//               {
//                 text: data.tciCertificateInfoPayload.motherNameEnglish,
//                 style: 'fatherMotherNidDynamicValue',
//               },
//               `, National ID/Birth Registration No: `,
//               {
//                 text:
//                   data.tciCertificateInfoPayload.nidEnglish || 'Not Provided',
//                 style: 'fatherMotherNidDynamicValue',
//               },
//               ` for successfully completing the requirements of the following units of competency:`,
//             ],
//             style: 'participantDetails',
//           },
//           {
//             absolutePosition: { x: 70, y: 490 },
//             width: 520,
//             height: 200,
//             margin: [0, 15, 0, 10],
//             columns: (() => {
//               const allItems = data.tciCertificateInfoPayload.competencyList
//                 ? data.tciCertificateInfoPayload.competencyList
//                     .split('\n')
//                     .filter((item: string) => item.trim() !== '')
//                     .sort((a: string, b: string) => a.localeCompare(b))
//                 : [];

//               const UoC = allItems.length;

//               const allShort37 = allItems.every((x: string | any[]) => x.length <= 37);
//               const allShort79 = allItems.every((x: string | any[]) => x.length <= 79);
//               const hasLong = allItems.some((x: string | any[]) => x.length >= 77);

//               // FORMATTER
//               const formatItem = (text: string) => ({
//                 columns: [
//                   { image: checkIconBase64, width: 8, margin: [0, 0, 5, 0] },
//                   {
//                     text,
//                     style: 'competencyListBN',
//                     noWrap: false,
//                     width: '*',
//                   },
//                 ],
//                 margin: [0, 2, 2, 2],
//                 columnGap: 5,
//               });

//               const formatList = (arr: string[]) => arr.map(formatItem);

//               //CONDITION 1: UoC < 13 AND ALL items <= 37 chars
//               if (UoC <= 13 && allShort37) {
//                 return [{ stack: formatList(allItems), width: '100%' }];
//               }

//               //CONDITION 2: UoC < 13 AND ALL items <= 75 chars
//               if (UoC <= 13 && allShort79) {
//                 return [{ stack: formatList(allItems), width: '100%' }];
//               }

//               //CONDITION 3: UoC > 13 AND ALL items <= 37 chars (two columns)
//               if (UoC > 13 && allShort37) {
//                 const mid = Math.ceil(UoC / 2);
//                 return [
//                   { stack: formatList(allItems.slice(0, mid)), width: '50%' },
//                   { stack: formatList(allItems.slice(mid)), width: '50%' },
//                 ];
//               }

//               const estimateHeight = (text: string): number => {
//                 const avgCharsPerLine = 65;
//                 const baseHeight = 13;
//                 const lines = Math.ceil(text.length / avgCharsPerLine);
//                 return baseHeight * lines;
//               };

//               const totalHeight = allItems.reduce(
//                 (sum: number, item: string) => sum + estimateHeight(item),
//                 0
//               );

//               let availableHeight = totalHeight > 170 ? 150 : 170;

//               const firstColumn: string[] = [];
//               const secondColumn: string[] = [];
//               let currentHeight = 0;

//               if (totalHeight > availableHeight) {
//                 for (const item of allItems) {
//                   const itemHeight = estimateHeight(item);
//                   if (currentHeight + itemHeight > availableHeight) {
//                     secondColumn.push(item);
//                   } else {
//                     firstColumn.push(item);
//                     currentHeight += itemHeight;
//                   }
//                 }
//               } else {
//                 firstColumn.push(...allItems);
//               }

//               return secondColumn.length > 0
//                 ? [
//                     { stack: formatList(firstColumn), width: '50%' },
//                     { stack: formatList(secondColumn), width: '50%' },
//                   ]
//                 : [{ stack: formatList(firstColumn), width: '100%' }];
//             })(),
//             columnGap: 15,
//           },
//           {
//             absolutePosition: { x: 30, y: 720 },
//             columns: [
//               {
//                 stack: [
//                   {
//                     table: {
//                       widths: ['auto', 'auto'],
//                       body: [
//                         [
//                           {
//                             text: 'Serial No.',
//                             style: 'footerLeftStatic',
//                           },
//                           {
//                             text: `: ${data.tciCertificateInfoPayload.serialNo}`,
//                             style: 'footerLeftDynamic',
//                           },
//                         ],
//                         [
//                           {
//                             text: 'Registration No.',
//                             style: 'footerLeftStatic',
//                           },
//                           {
//                             text: `: ${data.tciCertificateInfoPayload.registrationNo}`,
//                             style: 'footerLeftDynamic',
//                           },
//                         ],
//                         [
//                           {
//                             text: 'Result Published On',
//                             style: 'footerLeftStatic',
//                           },
//                           {
//                             text: `: ${data.tciCertificateInfoPayload.resultPublishedOn}`,
//                             style: 'footerLeftDynamic',
//                           },
//                         ],
//                         [
//                           {
//                             text: 'Valid until',
//                             style: 'footerLeftStatic',
//                           },
//                           {
//                             text: `: ${data.tciCertificateInfoPayload.validUntil}`,
//                             style: 'footerLeftDynamic',
//                           },
//                         ],
//                       ],
//                     },
//                     layout: 'noBorders',
//                   },
//                 ],
//                 width: '48%',
//               },

//               {
//                 image: `data:image/png;base64,${
//                   data.imageStringQR
//                     ? data.imageStringQR
//                     : data.tciCertificateInfoPayload?.imageStringQR
//                 }`,
//                 width: 80,
//                 alignment: 'center',
//                 margin: [10, -9, 10, 0],
//               },

//               {
//                 width: '35%',
//                 stack: [
//                   {
//                     image: chairmanSignatureBase64,
//                     width: 80,
//                     height: 30,
//                     alignment: 'center',
//                     margin: [0, 0, 0, 5],
//                   },
//                   {
//                     text: data.tciCertificateInfoPayload.chairmanEnglishName,
//                     style: 'chairmanNameEN',
//                   },
//                   {
//                     text: data.tciCertificateInfoPayload
//                       .chairmanEnglishDesignation,
//                     style: 'chairmanTextEN',
//                   },
//                 ],
//               },
//             ],
//             margin: [0, 10, 0, 0], // Adjust spacing
//           },

//           // Second Page: Bangla Content
//           { text: '', pageBreak: 'before' }, // Creates a new page
//           {
//             text: 'গণপ্রজাতন্ত্রী বাংলাদেশ সরকার',
//             style: 'headerBN',
//           },
//           {
//             text: data.tciCertificateInfoPayload.officeNameBangla,
//             style: 'subheaderGreenBN',
//           },
//           {
//             text: 'জাতীয় দক্ষতা উন্নয়ন কর্তৃপক্ষ (এনএসডিএ)',
//             style: 'subheaderBN',
//           },
//           {
//             text: 'জাতীয় দক্ষতা সনদ',
//             style: 'certificateTitleBN',
//           },
//           {
//             text: '',
//             style: 'labelOnBN',
//           },
//           {
//             text: data.tciCertificateInfoPayload.durationBangla
//               ? `${data.tciCertificateInfoPayload.certificateNameBangla} (${data.tciCertificateInfoPayload.durationBangla} ঘন্টা)`
//               : data.tciCertificateInfoPayload.certificateNameBangla,
//             style: 'courseTitleBN',
//           },
//           {
//             text: '[বাংলাদেশ ন্যাশনাল কোয়ালিফিকেশন ফ্রেমওয়ার্ক (বিএনকিউএফ) এর আওতায়]',
//             style: 'bnqfHeaderBN',
//           },
//           {
//             text: '',
//             style: 'labelIsAwardedToBN',
//           },
//           {
//             text: data.tciCertificateInfoPayload.participantNameBangla,
//             style: 'participantNameBN',
//           },
//           {
//             text: [
//               ` পিতা: `,
//               {
//                 text: data.tciCertificateInfoPayload.fatherNameBangla,
//                 style: 'fatherMotherNidDynamicValueBN',
//               },
//               `, মাতা: `,
//               {
//                 text: data.tciCertificateInfoPayload.motherNameBangla,
//                 style: 'fatherMotherNidDynamicValueBN',
//               },
//               `, জাতীয় পরিচয়পত্র / জন্ম নিবন্ধন নম্বর: `,
//               {
//                 text:
//                   data.tciCertificateInfoPayload.nidBangla || 'Not Provided',
//                 style: 'fatherMotherNidDynamicValueBN',
//               },
//               `-কে নিম্নোক্ত কম্পিটেন্সি ইউনিটসমূহ সফলভাবে সম্পন্ন করায়, জাতীয় দক্ষতা সনদ প্রদান করা হলো:`,
//             ],
//             style: 'participantDetailsBN',
//           },
//           {
//             absolutePosition: { x: 70, y: 480 },
//             width: 520,
//             height: 200,
//             margin: [0, 15, 0, 10],
//             columns: (() => {
//               const allItems = data.tciCertificateInfoPayload.competencyList
//                 ? data.tciCertificateInfoPayload.competencyList
//                     .split('\n')
//                     .filter((item: string) => item.trim() !== '')
//                     .sort((a: string, b: string) => a.localeCompare(b))
//                 : [];

//               const UoC = allItems.length;

//               const allShort37 = allItems.every((x: string | any[]) => x.length <= 37);
//               const allShort79 = allItems.every((x: string | any[]) => x.length <= 79);
//               const hasLong = allItems.some((x: string | any[]) => x.length >= 77);

//               // FORMATTER
//               const formatItem = (text: string) => ({
//                 columns: [
//                   { image: checkIconBase64, width: 8, margin: [0, -4, 5, 0] },
//                   {
//                     text,
//                     style: 'competencyListBN',
//                     noWrap: false,
//                     width: '*',
//                   },
//                 ],
//                 margin: [0, 2, 2, 2],
//                 columnGap: 5,
//               });

//               const formatList = (arr: string[]) => arr.map(formatItem);

//               //CONDITION 1: UoC < 13 AND ALL items <= 37 chars
//               if (UoC <= 13 && allShort37) {
//                 return [{ stack: formatList(allItems), width: '100%' }];
//               }

//               //CONDITION 2: UoC < 13 AND ALL items <= 75 chars
//               if (UoC <= 13 && allShort79) {
//                 return [{ stack: formatList(allItems), width: '100%' }];
//               }

//               //CONDITION 3: UoC > 13 AND ALL items <= 37 chars (two columns)
//               if (UoC > 13 && allShort37) {
//                 const mid = Math.ceil(UoC / 2);
//                 return [
//                   { stack: formatList(allItems.slice(0, mid)), width: '50%' },
//                   { stack: formatList(allItems.slice(mid)), width: '50%' },
//                 ];
//               }

//               const estimateHeight = (text: string): number => {
//                 const avgCharsPerLine = 65;
//                 const baseHeight = 13;
//                 const lines = Math.ceil(text.length / avgCharsPerLine);
//                 return baseHeight * lines;
//               };

//               const totalHeight = allItems.reduce(
//                 (sum: number, item: string) => sum + estimateHeight(item),
//                 0
//               );

//               let availableHeight = totalHeight > 170 ? 150 : 170;

//               const firstColumn: string[] = [];
//               const secondColumn: string[] = [];
//               let currentHeight = 0;

//               if (totalHeight > availableHeight) {
//                 for (const item of allItems) {
//                   const itemHeight = estimateHeight(item);
//                   if (currentHeight + itemHeight > availableHeight) {
//                     secondColumn.push(item);
//                   } else {
//                     firstColumn.push(item);
//                     currentHeight += itemHeight;
//                   }
//                 }
//               } else {
//                 firstColumn.push(...allItems);
//               }

//               return secondColumn.length > 0
//                 ? [
//                     { stack: formatList(firstColumn), width: '50%' },
//                     { stack: formatList(secondColumn), width: '50%' },
//                   ]
//                 : [{ stack: formatList(firstColumn), width: '100%' }];
//             })(),
//             columnGap: 15,
//           },
//           {
//             absolutePosition: { x: 30, y: 720 },
//             columns: [
//               {
//                 stack: [
//                   {
//                     table: {
//                       widths: ['auto', 'auto'],
//                       body: [
//                         [
//                           {
//                             text: 'ক্রমিক নম্বর',
//                             style: 'footerLeftStaticBN',
//                           },
//                           {
//                             text: `: ${data.tciCertificateInfoPayload.serialNo}`,
//                             style: 'footerLeftDynamic',
//                           },
//                         ],
//                         [
//                           {
//                             text: 'রেজিস্ট্রেশন নম্বর',
//                             style: 'footerLeftStaticBN',
//                           },
//                           {
//                             text: `: ${data.tciCertificateInfoPayload.registrationNo}`,
//                             style: 'footerLeftDynamic',
//                           },
//                         ],
//                         [
//                           {
//                             text: 'ফলাফল প্রকাশের তারিখ',
//                             style: 'footerLeftStaticBN',
//                           },
//                           {
//                             text: `: ${data.tciCertificateInfoPayload.resultPublishedOnBangla}`,
//                             style: 'footerLeftDynamicBN',
//                           },
//                         ],
//                         [
//                           {
//                             text: 'মেয়াদোত্তীর্ণের তারিখ',
//                             style: 'footerLeftStaticBN',
//                           },
//                           {
//                             text: `: ${data.tciCertificateInfoPayload.validUntilBangla}`,
//                             style: 'footerLeftDynamicBN',
//                           },
//                         ],
//                       ],
//                     },
//                     layout: 'noBorders',
//                   },
//                 ],
//                 width: '48%',
//               },

//               {
//                 image: `data:image/png;base64,${data.imageStringQR}`,
//                 width: 80,
//                 alignment: 'center',
//                 margin: [10, -9, 10, 0],
//               },

//               {
//                 width: '35%',
//                 stack: [
//                   {
//                     image: chairmanSignatureBase64,
//                     width: 80,
//                     height: 30,
//                     alignment: 'center',
//                     margin: [0, 0, 0, 5],
//                   },
//                   {
//                     text: data.tciCertificateInfoPayload.chairmanBanglaName,
//                     style: 'chairmanNameBN',
//                   },
//                   {
//                     text: data.tciCertificateInfoPayload
//                       .chairmanBanglaDesignation,
//                     style: 'chairmanTextBN',
//                   },
//                 ],
//               },
//             ],
//             margin: [0, 10, 0, 0], // Adjust spacing
//           },
//         ],

//         images: {
//           bgImage: bgImageBase64,
//           checkIcon: checkIconBase64,
//           chairmanSignature: chairmanSignatureBase64,
//         },

//         styles: {
//           //English
//           header: {
//             fontSize: 17,
//             alignment: 'center',
//             margin: [0, 114, 0, 10],
//           },
//           subheader: {
//             fontSize: 12,
//             bold: true,
//             alignment: 'center',
//             margin: [0, 0, 0, 10],
//           },
//           subheaderGreen: {
//             fontSize: 29,
//             font: 'Calibri',
//             bold: true,
//             alignment: 'center',
//             color: 'green',
//             margin: [0, -3, 0, 10],
//           },
//           certificateTitle: {
//             fontSize: 25,
//             font: 'Calibri',
//             bold: true,
//             alignment: 'center',
//             margin: [0, 20, 0, 0],
//           },
//           labelOn: {
//             fontSize: 12,
//             font: 'Carattere',
//             italics: true,
//             alignment: 'center',
//             margin: [0, 5, 0, 0],
//           },
//           bnqfHeader: {
//             fontSize: 12,
//             font: 'Roboto',
//             alignment: 'center',
//             margin: [0, 5, 0, 0],
//           },
//           labelIsAwardedTo: {
//             fontSize: 12,
//             font: 'Carattere',
//             italics: true,
//             alignment: 'center',
//             margin: [0, 23, 0, 0],
//           },
//           courseTitle: {
//             fontSize: 16,
//             alignment: 'center',
//             margin: [0, 5, 0, 0],
//           },
//           participantName: {
//             fontSize: 25,
//             // font: 'OldEnglishTexTmt',
//             bold: true,
//             alignment: 'center',
//             margin: [0, 5, 0, 10],
//           },
//           fatherMotherNidDynamicValue: {
//             // font: 'OldEnglishTexTmt',
//             // bold: true,
//           },
//           participantDetails: {
//             fontSize: 11,
//             alignment: 'center',
//             margin: [10, 0, 10, 0],
//             lineHeight: 1.5,
//           },
//           competencyListEN: {
//             font: 'Roboto',
//             italics: true,
//             fontSize: 10,
//             lineHeight: 1.2,
//             margin: [0, -2, 0, 0],
//           },
//           footerLeftStatic: {
//             fontSize: 11,
//             alignment: 'left',
//             font: 'Carattere',
//             bold: true,
//             margin: [25, 0, -7, 0],
//           },
//           footerLeftDynamic: { fontSize: 9, alignment: 'left', italics: true },
//           chairmanNameEN: {
//             fontSize: 11,
//             alignment: 'center',
//             font: 'Carattere',
//             bold: true,
//             margin: [0, 2, 0, 2],
//           },
//           chairmanTextEN: {
//             fontSize: 12,
//             alignment: 'center',
//             font: 'Carattere',
//             bold: true,
//             margin: [0, 0, 0, 0],
//           },

//           //Bangla
//           headerBN: {
//             font: 'NikoshBAN',
//             fontSize: 28,
//             bold: true,
//             alignment: 'center',
//             margin: [0, 114, 0, 10],
//           },
//           subheaderBN: {
//             font: 'NikoshBAN',
//             fontSize: 22,
//             bold: true,
//             alignment: 'center',
//             margin: [0, -10, 0, 10],
//           },
//           subheaderGreenBN: {
//             font: 'NikoshBAN',
//             fontSize: 30,
//             bold: true,
//             alignment: 'center',
//             color: 'green',
//             margin: [0, -12, 0, 10],
//           },
//           certificateTitleBN: {
//             font: 'NikoshBAN',
//             fontSize: 28,
//             bold: true,
//             alignment: 'center',
//             margin: [0, 20, 0, 0],
//           },
//           labelOnBN: {
//             font: 'NikoshBAN',
//             fontSize: 12,
//             italics: true,
//             bold: true,
//             alignment: 'center',
//             margin: [0, 5, 0, 0],
//           },
//           bnqfHeaderBN: {
//             fontSize: 12,
//             font: 'NikoshBAN',
//             alignment: 'center',
//             margin: [0, 5, 0, 0],
//           },
//           labelIsAwardedToBN: {
//             font: 'NikoshBAN',
//             fontSize: 12,
//             italics: true,
//             bold: true,
//             alignment: 'center',
//             margin: [0, 23, 0, 0],
//           },
//           courseTitleBN: {
//             font: 'NikoshBAN',
//             fontSize: 23,
//             alignment: 'center',
//             margin: [0, -5, 0, 0],
//           },
//           participantNameBN: {
//             font: 'NikoshBAN',
//             fontSize: 20,
//             bold: true,
//             alignment: 'center',
//             margin: [0, 5, 0, 10],
//           },
//           fatherMotherNidDynamicValueBN: {
//             font: 'NikoshBAN',
//             italics: true,
//             //bold: true,
//           },
//           participantDetailsBN: {
//             font: 'NikoshBAN',
//             fontSize: 12,
//             alignment: 'center',
//             margin: [10, 0, 10, 0],
//             lineHeight: 1.5,
//           },
//           competencyListBN: {
//             font: 'Roboto',
//             italics: true,
//             fontSize: 10,
//             lineHeight: 1.5,
//             margin: [0, -6, 0, 0],
//           },
//           footerLeftStaticBN: {
//             font: 'NikoshBAN',
//             fontSize: 11,
//             alignment: 'left',
//             bold: true,
//             margin: [25, 0, -7, 0],
//           },
//           footerLeftDynamicBN: {
//             font: 'NikoshBAN',
//             fontSize: 9,
//             alignment: 'left',
//             italics: true,
//           },
//           chairmanNameBN: {
//             font: 'NikoshBAN',
//             fontSize: 11,
//             alignment: 'center',
//             bold: true,
//             margin: [0, 2, 0, 2],
//           },
//           chairmanTextBN: {
//             font: 'NikoshBAN',
//             fontSize: 12,
//             alignment: 'center',
//             bold: true,
//             margin: [0, 0, 0, 0],
//           },
//         },
//       };

//       pdfMake
//         .createPdf(documentDefinition)
//         .download(
//           `Certificate_${data.tciCertificateInfoPayload.participantName}.pdf`
//         );
//     } catch (error) {
//       console.error('Error loading images:', error);
//     }
//   }

//   async onCertificateDownloadREG(data: any) {
//     try {
//       const bgImageBase64 = await this.getBase64ImageFromURL(
//         '/assets/certificate/new_certificate_files_by_pdf_make/bg.jpg'
//       );
//       const checkIconBase64 = await this.getBase64ImageFromURL(
//         '/assets/certificate/new_certificate_files_by_pdf_make/green-check-mark.jpeg'
//       );

//       let fileUrl = data.chairmanSignatureFilePath;
//       let chairmanSignatureBase64 = await this.getChairmanImageBase64(fileUrl);

//       await this.loadFontToVFS('/assets/fonts/NikoshBAN.ttf', 'NikoshBAN');
//       await this.loadFontToVFS(
//         '/assets/fonts/Carattere/Carattere-Regular.ttf',
//         'Carattere-Regular'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Edwardian-Script/edwardianscriptitc.ttf',
//         'edwardianscriptitc'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Edwardian-Script/edwardian-script-itc-bold.ttf',
//         'edwardianscriptitcb'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Old-English-Text-MT/oldenglishtextmt.ttf',
//         'oldenglishtextmt'
//       );

//       await this.loadFontToVFS(
//         '/assets/fonts/Calibri/calibri-bold-italic.ttf',
//         'calibri-bold-italic'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Calibri/calibri-bold.ttf',
//         'calibri-bold'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Calibri/calibri-italic.ttf',
//         'calibri-italic'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Calibri/calibri-regular.ttf',
//         'calibri-regular'
//       );

//       (pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
//       (pdfMake as any).fonts = {
//         NikoshBAN: {
//           normal: 'NikoshBAN.ttf',
//           bold: 'NikoshBAN.ttf',
//           italics: 'NikoshBAN.ttf',
//           bolditalics: 'NikoshBAN.ttf',
//         },
//         Roboto: {
//           normal: 'Roboto-Regular.ttf',
//           bold: 'Roboto-Medium.ttf',
//           italics: 'Roboto-Italic.ttf',
//           bolditalics: 'Roboto-MediumItalic.ttf',
//         },
//         EdwardianScriptItc: {
//           normal: 'edwardianscriptitc.ttf',
//           bold: 'edwardianscriptitcb.ttf',
//           italics: 'edwardianscriptitc.ttf',
//           bolditalics: 'edwardianscriptitc.ttf',
//         },
//         Carattere: {
//           normal: 'Carattere-Regular.ttf',
//           bold: 'Carattere-Regular.ttf',
//           italics: 'Carattere-Regular.ttf',
//           bolditalics: 'Carattere-Regular.ttf',
//         },
//         OldEnglishTexTmt: {
//           normal: 'oldenglishtextmt.ttf',
//           bold: 'oldenglishtextmt.ttf',
//           italics: 'oldenglishtextmt.ttf',
//           bolditalics: 'oldenglishtextmt.ttf',
//         },
//         Calibri: {
//           normal: 'calibri-regular.ttf',
//           bold: 'calibri-bold.ttf',
//           italics: 'calibri-italic.ttf',
//           bolditalics: 'calibri-bold-italic.ttf',
//         },
//       };

//       const documentDefinition: any = {
//         pageSize: 'A4',
//         pageMargins: [40, 40, 40, 40],

//         background: [
//           {
//             image: 'bgImage',
//             width: 595,
//             height: 842,
//             absolutePosition: { x: 0, y: 0 },
//           },
//         ],

//         content: [
//           {
//             text: 'Government of the People’s Republic of Bangladesh',
//             style: 'header',
//           },
//           {
//             text: data.officeNameEnglish,
//             style: 'subheaderGreen',
//           },
//           {
//             text: 'NATIONAL SKILLS DEVELOPMENT AUTHORITY (NSDA)',
//             style: 'subheader',
//           },
//           {
//             text:
//               data.isCompetent == true
//                 ? 'National Skills Certificate'
//                 : 'Statement of Achievement',
//             style: 'certificateTitle',
//           },
//           {
//             text: 'on',
//             style: 'labelOn',
//           },
//           {
//             text: data.duration
//               ? `${data.certificateName} (${data.duration} hours)`
//               : data.certificateName,
//             style: 'courseTitle',
//           },
//           {
//             text: '[Under the Bangladesh National Qualification Framework (BNQF)]',
//             style: 'bnqfHeader',
//           },
//           {
//             text: 'is awarded to',
//             style: 'labelIsAwardedTo',
//           },
//           {
//             text: data.participantName,
//             style: 'participantName',
//           },

//           {
//             text: [
//               `Father's Name: `,
//               {
//                 text: data.fatherNameEnglish,
//                 style: 'fatherMotherNidDynamicValue',
//               },
//               `, Mother's Name: `,
//               {
//                 text: data.motherNameEnglish,
//                 style: 'fatherMotherNidDynamicValue',
//               },
//               `, National ID/Birth Registration No: `,
//               {
//                 text: data.nidEnglish || 'Not Provided',
//                 style: 'fatherMotherNidDynamicValue',
//               },
//               ` for successfully completing the requirements of the following units of competency:`,
//             ],
//             style: 'participantDetails',
//           },
//           {
//             absolutePosition: { x: 70, y: 490 },
//             width: 520,
//             height: 200,
//             margin: [0, 15, 0, 10],
//             columns: (() => {
//               const allItems = data.competencyList
//                 ? data.competencyList
//                     .split('\n')
//                     .filter((item: string) => item.trim() !== '')
//                     .sort((a: string, b: string) => a.localeCompare(b))
//                 : [];

//               const UoC = allItems.length;

//               const allShort37 = allItems.every((x: string | any[]) => x.length <= 37);
//               const allShort79 = allItems.every((x: string | any[]) => x.length <= 79);
//               const hasLong = allItems.some((x: string | any[]) => x.length >= 77);

//               // FORMATTER
//               const formatItem = (text: string) => ({
//                 columns: [
//                   { image: checkIconBase64, width: 8, margin: [0, 0, 5, 0] },
//                   {
//                     text,
//                     style: 'competencyListEN',
//                     noWrap: false,
//                     width: '*',
//                   },
//                 ],
//                 margin: [0, 2, 2, 2],
//                 columnGap: 5,
//               });

//               const formatList = (arr: string[]) => arr.map(formatItem);

//               //CONDITION 1: UoC < 13 AND ALL items <= 37 chars
//               if (UoC <= 13 && allShort37) {
//                 return [{ stack: formatList(allItems), width: '100%' }];
//               }

//               //CONDITION 2: UoC < 13 AND ALL items <= 75 chars
//               if (UoC <= 13 && allShort79) {
//                 return [{ stack: formatList(allItems), width: '100%' }];
//               }

//               //CONDITION 3: UoC > 13 AND ALL items <= 37 chars (two columns)
//               if (UoC > 13 && allShort37) {
//                 const mid = Math.ceil(UoC / 2);
//                 return [
//                   { stack: formatList(allItems.slice(0, mid)), width: '50%' },
//                   { stack: formatList(allItems.slice(mid)), width: '50%' },
//                 ];
//               }

//               const estimateHeight = (text: string): number => {
//                 const avgCharsPerLine = 65;
//                 const baseHeight = 13;
//                 const lines = Math.ceil(text.length / avgCharsPerLine);
//                 return baseHeight * lines;
//               };

//               const totalHeight = allItems.reduce(
//                 (sum: number, item: string) => sum + estimateHeight(item),
//                 0
//               );

//               let availableHeight = totalHeight > 170 ? 150 : 170;

//               const firstColumn: string[] = [];
//               const secondColumn: string[] = [];
//               let currentHeight = 0;

//               if (totalHeight > availableHeight) {
//                 for (const item of allItems) {
//                   const itemHeight = estimateHeight(item);
//                   if (currentHeight + itemHeight > availableHeight) {
//                     secondColumn.push(item);
//                   } else {
//                     firstColumn.push(item);
//                     currentHeight += itemHeight;
//                   }
//                 }
//               } else {
//                 firstColumn.push(...allItems);
//               }

//               return secondColumn.length > 0
//                 ? [
//                     { stack: formatList(firstColumn), width: '50%' },
//                     { stack: formatList(secondColumn), width: '50%' },
//                   ]
//                 : [{ stack: formatList(firstColumn), width: '100%' }];
//             })(),
//             columnGap: 15,
//           },
//           {
//             absolutePosition: { x: 30, y: 720 },
//             columns: [
//               {
//                 stack: [
//                   {
//                     table: {
//                       widths: ['auto', 'auto'],
//                       body: [
//                         [
//                           {
//                             text: 'Serial No.',
//                             style: 'footerLeftStatic',
//                           },
//                           {
//                             text: `: ${data.serialNo}`,
//                             style: 'footerLeftDynamic',
//                           },
//                         ],
//                         [
//                           {
//                             text: 'Registration No.',
//                             style: 'footerLeftStatic',
//                           },
//                           {
//                             text: `: ${data.registrationNo}`,
//                             style: 'footerLeftDynamic',
//                           },
//                         ],
//                         [
//                           {
//                             text: 'Result Published On',
//                             style: 'footerLeftStatic',
//                           },
//                           {
//                             text: `: ${data.resultPublishedOn}`,
//                             style: 'footerLeftDynamic',
//                           },
//                         ],
//                         [
//                           {
//                             text: 'Valid until',
//                             style: 'footerLeftStatic',
//                           },
//                           {
//                             text: `: ${data.validUntil}`,
//                             style: 'footerLeftDynamic',
//                           },
//                         ],
//                       ],
//                     },
//                     layout: 'noBorders',
//                   },
//                 ],
//                 width: '48%',
//               },

//               {
//                 image: `data:image/png;base64,${data.imageStringQR}`,
//                 width: 80,
//                 alignment: 'center',
//                 margin: [10, -9, 10, 0],
//               },

//               {
//                 width: '35%',
//                 stack: [
//                   {
//                     image: chairmanSignatureBase64,
//                     width: 80,
//                     height: 30,
//                     alignment: 'center',
//                     margin: [0, 0, 0, 5],
//                   },
//                   {
//                     text: data.chairmanEnglishName,
//                     style: 'chairmanNameEN',
//                   },
//                   {
//                     text: data.chairmanEnglishDesignation,
//                     style: 'chairmanTextEN',
//                   },
//                 ],
//               },
//             ],
//             margin: [0, 10, 0, 0], // Adjust spacing
//           },

//           // Second Page: Bangla Content
//           { text: '', pageBreak: 'before' }, // Creates a new page
//           {
//             text: 'গণপ্রজাতন্ত্রী বাংলাদেশ সরকার',
//             style: 'headerBN',
//           },
//           {
//             text: data.officeNameBangla,
//             style: 'subheaderGreenBN',
//           },
//           {
//             text: 'জাতীয় দক্ষতা উন্নয়ন কর্তৃপক্ষ (এনএসডিএ)',
//             style: 'subheaderBN',
//           },
//           {
//             text:
//               data.isCompetent == true
//                 ? 'জাতীয় দক্ষতা সনদ'
//                 : 'স্টেটমেন্ট অব অ্যাচিভমেন্ট',
//             style: 'certificateTitleBN',
//           },
//           {
//             text: '',
//             style: 'labelOnBN',
//           },
//           {
//             text: data.durationBangla
//               ? `${data.certificateNameBangla} (${data.durationBangla} ঘন্টা)`
//               : data.certificateNameBangla,
//             style: 'courseTitleBN',
//           },
//           {
//             text: '[বাংলাদেশ ন্যাশনাল কোয়ালিফিকেশন ফ্রেমওয়ার্ক (বিএনকিউএফ) এর আওতায়]',
//             style: 'bnqfHeaderBN',
//           },
//           {
//             text: '',
//             style: 'labelIsAwardedToBN',
//           },
//           {
//             text: data.participantNameBangla,
//             style: 'participantNameBN',
//           },

//           {
//             text: [
//               ` পিতা: `,
//               {
//                 text: data.fatherNameBangla,
//                 style: 'fatherMotherNidDynamicValueBN',
//               },
//               `, মাতা: `,
//               {
//                 text: data.motherNameBangla,
//                 style: 'fatherMotherNidDynamicValueBN',
//               },
//               `, জাতীয় পরিচয়পত্র / জন্ম নিবন্ধন নম্বর: `,
//               {
//                 text: data.nidBangla || 'Not Provided',
//                 style: 'fatherMotherNidDynamicValueBN',
//               },
//               `-কে নিম্নোক্ত কম্পিটেন্সি ইউনিটসমূহ সফলভাবে সম্পন্ন করায়, জাতীয় দক্ষতা সনদ প্রদান করা হলো:`,
//             ],
//             style: 'participantDetailsBN',
//           },

//           {
//             absolutePosition: { x: 70, y: 480 },
//             width: 520,
//             height: 200,
//             margin: [0, 15, 0, 10],
//             columns: (() => {
//               const allItems = data.competencyList
//                 ? data.competencyList
//                     .split('\n')
//                     .filter((item: string) => item.trim() !== '')
//                     .sort((a: string, b: string) => a.localeCompare(b))
//                 : [];

//               const UoC = allItems.length;

//               const allShort37 = allItems.every((x: string | any[]) => x.length <= 37);
//               const allShort79 = allItems.every((x: string | any[]) => x.length <= 79);
//               const hasLong = allItems.some((x: string | any[]) => x.length >= 77);

//               // FORMATTER
//               const formatItem = (text: string) => ({
//                 columns: [
//                   { image: checkIconBase64, width: 8, margin: [0, -4, 5, 0] },
//                   {
//                     text,
//                     style: 'competencyListBN',
//                     noWrap: false,
//                     width: '*',
//                   },
//                 ],
//                 margin: [0, 2, 2, 2],
//                 columnGap: 5,
//               });

//               const formatList = (arr: string[]) => arr.map(formatItem);

//               //CONDITION 1: UoC < 13 AND ALL items <= 37 chars
//               if (UoC <= 13 && allShort37) {
//                 return [{ stack: formatList(allItems), width: '100%' }];
//               }

//               //CONDITION 2: UoC < 13 AND ALL items <= 75 chars
//               if (UoC <= 13 && allShort79) {
//                 return [{ stack: formatList(allItems), width: '100%' }];
//               }

//               //CONDITION 3: UoC > 13 AND ALL items <= 37 chars (two columns)
//               if (UoC > 13 && allShort37) {
//                 const mid = Math.ceil(UoC / 2);
//                 return [
//                   { stack: formatList(allItems.slice(0, mid)), width: '50%' },
//                   { stack: formatList(allItems.slice(mid)), width: '50%' },
//                 ];
//               }

//               const estimateHeight = (text: string): number => {
//                 const avgCharsPerLine = 65;
//                 const baseHeight = 13;
//                 const lines = Math.ceil(text.length / avgCharsPerLine);
//                 return baseHeight * lines;
//               };

//               const totalHeight = allItems.reduce(
//                 (sum: number, item: string) => sum + estimateHeight(item),
//                 0
//               );

//               let availableHeight = totalHeight > 170 ? 150 : 170;

//               const firstColumn: string[] = [];
//               const secondColumn: string[] = [];
//               let currentHeight = 0;

//               if (totalHeight > availableHeight) {
//                 for (const item of allItems) {
//                   const itemHeight = estimateHeight(item);
//                   if (currentHeight + itemHeight > availableHeight) {
//                     secondColumn.push(item);
//                   } else {
//                     firstColumn.push(item);
//                     currentHeight += itemHeight;
//                   }
//                 }
//               } else {
//                 firstColumn.push(...allItems);
//               }

//               return secondColumn.length > 0
//                 ? [
//                     { stack: formatList(firstColumn), width: '50%' },
//                     { stack: formatList(secondColumn), width: '50%' },
//                   ]
//                 : [{ stack: formatList(firstColumn), width: '100%' }];
//             })(),
//             columnGap: 15,
//           },

//           {
//             absolutePosition: { x: 30, y: 720 },
//             columns: [
//               {
//                 stack: [
//                   {
//                     table: {
//                       widths: ['auto', 'auto'],
//                       body: [
//                         [
//                           {
//                             text: 'ক্রমিক নম্বর',
//                             style: 'footerLeftStaticBN',
//                           },
//                           {
//                             text: `: ${data.serialNo}`,
//                             style: 'footerLeftDynamic',
//                           },
//                         ],
//                         [
//                           {
//                             text: 'রেজিস্ট্রেশন নম্বর',
//                             style: 'footerLeftStaticBN',
//                           },
//                           {
//                             text: `: ${data.registrationNo}`,
//                             style: 'footerLeftDynamic',
//                           },
//                         ],
//                         [
//                           {
//                             text: 'ফলাফল প্রকাশের তারিখ',
//                             style: 'footerLeftStaticBN',
//                           },
//                           {
//                             text: `: ${data.resultPublishedOnBangla}`,
//                             style: 'footerLeftDynamicBN',
//                           },
//                         ],
//                         [
//                           {
//                             text: 'মেয়াদোত্তীর্ণের তারিখ',
//                             style: 'footerLeftStaticBN',
//                           },
//                           {
//                             text: `: ${data.validUntilBangla}`,
//                             style: 'footerLeftDynamicBN',
//                           },
//                         ],
//                       ],
//                     },
//                     layout: 'noBorders',
//                   },
//                 ],
//                 width: '48%',
//               },

//               {
//                 image: `data:image/png;base64,${data.imageStringQR}`,
//                 width: 80,
//                 alignment: 'center',
//                 margin: [10, -9, 10, 0],
//               },

//               {
//                 width: '35%',
//                 stack: [
//                   {
//                     image: chairmanSignatureBase64,
//                     width: 80,
//                     height: 30,
//                     alignment: 'center',
//                     margin: [0, 0, 0, 5],
//                   },
//                   {
//                     text: data.chairmanBanglaName,
//                     style: 'chairmanNameBN',
//                   },
//                   {
//                     text: data.chairmanBanglaDesignation,
//                     style: 'chairmanTextBN',
//                   },
//                 ],
//               },
//             ],
//             margin: [0, 10, 0, 0], // Adjust spacing
//           },
//         ],

//         images: {
//           bgImage: bgImageBase64,
//           checkIcon: checkIconBase64,
//           chairmanSignature: chairmanSignatureBase64,
//         },

//         styles: {
//           //English
//           header: {
//             fontSize: 17,
//             alignment: 'center',
//             margin: [0, 114, 0, 10],
//           },
//           subheader: {
//             fontSize: 12,
//             bold: true,
//             alignment: 'center',
//             margin: [0, 0, 0, 10],
//           },
//           subheaderGreen: {
//             fontSize: 29,
//             font: 'Calibri',
//             bold: true,
//             alignment: 'center',
//             color: 'green',
//             margin: [0, -3, 0, 10],
//           },
//           certificateTitle: {
//             fontSize: 25,
//             font: 'Calibri',
//             bold: true,
//             alignment: 'center',
//             margin: [0, 20, 0, 0],
//           },
//           labelOn: {
//             fontSize: 12,
//             font: 'Carattere',
//             italics: true,
//             alignment: 'center',
//             margin: [0, 5, 0, 0],
//           },
//           bnqfHeader: {
//             fontSize: 12,
//             font: 'Roboto',
//             alignment: 'center',
//             margin: [0, 5, 0, 0],
//           },
//           labelIsAwardedTo: {
//             fontSize: 12,
//             font: 'Carattere',
//             italics: true,
//             alignment: 'center',
//             margin: [0, 23, 0, 0],
//           },
//           courseTitle: {
//             fontSize: 16,
//             alignment: 'center',
//             margin: [0, 5, 0, 0],
//           },
//           participantName: {
//             fontSize: 25,
//             // font: 'OldEnglishTexTmt',
//             bold: true,
//             alignment: 'center',
//             margin: [0, 5, 0, 10],
//           },
//           fatherMotherNidDynamicValue: {
//             // font: 'OldEnglishTexTmt',
//             // italics: true,
//             //bold: true,
//           },
//           participantDetails: {
//             fontSize: 11,
//             alignment: 'center',
//             margin: [10, 0, 10, 0],
//             lineHeight: 1.5,
//           },
//           competencyListEN: {
//             font: 'Roboto',
//             italics: true,
//             fontSize: 10,
//             lineHeight: 1.2,
//             margin: [0, -2, 0, 0],
//           },
//           footerLeftStatic: {
//             fontSize: 11,
//             alignment: 'left',
//             font: 'Carattere',
//             bold: true,
//             margin: [25, 0, -7, 0],
//           },
//           footerLeftDynamic: { fontSize: 9, alignment: 'left', italics: true },
//           chairmanNameEN: {
//             fontSize: 11,
//             alignment: 'center',
//             font: 'Carattere',
//             bold: true,
//             margin: [0, 2, 0, 2],
//           },
//           chairmanTextEN: {
//             fontSize: 12,
//             alignment: 'center',
//             font: 'Carattere',
//             bold: true,
//             margin: [0, 0, 0, 0],
//           },

//           //Bangla
//           headerBN: {
//             font: 'NikoshBAN',
//             fontSize: 28,
//             bold: true,
//             alignment: 'center',
//             margin: [0, 114, 0, 10],
//           },
//           subheaderBN: {
//             font: 'NikoshBAN',
//             fontSize: 22,
//             bold: true,
//             alignment: 'center',
//             margin: [0, -10, 0, 10],
//           },
//           subheaderGreenBN: {
//             font: 'NikoshBAN',
//             fontSize: 30,
//             bold: true,
//             alignment: 'center',
//             color: 'green',
//             margin: [0, -12, 0, 10],
//           },
//           certificateTitleBN: {
//             font: 'NikoshBAN',
//             fontSize: 28,
//             bold: true,
//             alignment: 'center',
//             margin: [0, 20, 0, 0],
//           },
//           labelOnBN: {
//             font: 'NikoshBAN',
//             fontSize: 12,
//             italics: true,
//             bold: true,
//             alignment: 'center',
//             margin: [0, 5, 0, 0],
//           },
//           bnqfHeaderBN: {
//             fontSize: 12,
//             font: 'NikoshBAN',
//             alignment: 'center',
//             margin: [0, 5, 0, 0],
//           },
//           labelIsAwardedToBN: {
//             font: 'NikoshBAN',
//             fontSize: 12,
//             italics: true,
//             bold: true,
//             alignment: 'center',
//             margin: [0, 23, 0, 0],
//           },
//           courseTitleBN: {
//             font: 'NikoshBAN',
//             fontSize: 23,
//             alignment: 'center',
//             margin: [0, -5, 0, 0],
//           },
//           participantNameBN: {
//             font: 'NikoshBAN',
//             fontSize: 20,
//             bold: true,
//             alignment: 'center',
//             margin: [0, 5, 0, 10],
//           },
//           fatherMotherNidDynamicValueBN: {
//             font: 'NikoshBAN',
//             italics: true,
//             //bold: true,
//           },
//           participantDetailsBN: {
//             font: 'NikoshBAN',
//             fontSize: 12,
//             alignment: 'center',
//             margin: [10, 0, 10, 0],
//             lineHeight: 1.5,
//           },
//           competencyListBN: {
//             font: 'Roboto',
//             italics: true,
//             fontSize: 10,
//             lineHeight: 1.5,
//             margin: [0, -6, 0, 0],
//           },
//           footerLeftStaticBN: {
//             font: 'NikoshBAN',
//             fontSize: 11,
//             alignment: 'left',
//             bold: true,
//             margin: [25, 0, -7, 0],
//           },
//           footerLeftDynamicBN: {
//             font: 'NikoshBAN',
//             fontSize: 9,
//             alignment: 'left',
//             italics: true,
//           },
//           chairmanNameBN: {
//             font: 'NikoshBAN',
//             fontSize: 11,
//             alignment: 'center',
//             bold: true,
//             margin: [0, 2, 0, 2],
//           },
//           chairmanTextBN: {
//             font: 'NikoshBAN',
//             fontSize: 12,
//             alignment: 'center',
//             bold: true,
//             margin: [0, 0, 0, 0],
//           },
//         },
//       };

//       pdfMake
//         .createPdf(documentDefinition)
//         .download(`Certificate_${data.participantName}.pdf`);
//     } catch (error) {
//       console.error('Error loading images:', error);
//     }
//   }

//   async onCertificateDownloadRPL(data: any) {
//     try {
//       const bgImageBase64 = await this.getBase64ImageFromURL(
//         '/assets/certificate/new_certificate_files_by_pdf_make/bg.jpg'
//       );
//       const checkIconBase64 = await this.getBase64ImageFromURL(
//         '/assets/certificate/new_certificate_files_by_pdf_make/green-check-mark.jpeg'
//       );

//       let fileUrl = data.chairmanSignatureFilePath;
//       let chairmanSignatureBase64 = await this.getChairmanImageBase64(fileUrl);

//       await this.loadFontToVFS('/assets/fonts/NikoshBAN.ttf', 'NikoshBAN');
//       await this.loadFontToVFS(
//         '/assets/fonts/Carattere/Carattere-Regular.ttf',
//         'Carattere-Regular'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Edwardian-Script/edwardianscriptitc.ttf',
//         'edwardianscriptitc'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Edwardian-Script/edwardian-script-itc-bold.ttf',
//         'edwardianscriptitcb'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Old-English-Text-MT/oldenglishtextmt.ttf',
//         'oldenglishtextmt'
//       );

//       await this.loadFontToVFS(
//         '/assets/fonts/Calibri/calibri-bold-italic.ttf',
//         'calibri-bold-italic'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Calibri/calibri-bold.ttf',
//         'calibri-bold'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Calibri/calibri-italic.ttf',
//         'calibri-italic'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Calibri/calibri-regular.ttf',
//         'calibri-regular'
//       );

//       (pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
//       (pdfMake as any).fonts = {
//         NikoshBAN: {
//           normal: 'NikoshBAN.ttf',
//           bold: 'NikoshBAN.ttf',
//           italics: 'NikoshBAN.ttf',
//           bolditalics: 'NikoshBAN.ttf',
//         },
//         Roboto: {
//           normal: 'Roboto-Regular.ttf',
//           bold: 'Roboto-Medium.ttf',
//           italics: 'Roboto-Italic.ttf',
//           bolditalics: 'Roboto-MediumItalic.ttf',
//         },
//         EdwardianScriptItc: {
//           normal: 'edwardianscriptitc.ttf',
//           bold: 'edwardianscriptitcb.ttf',
//           italics: 'edwardianscriptitc.ttf',
//           bolditalics: 'edwardianscriptitc.ttf',
//         },
//         Carattere: {
//           normal: 'Carattere-Regular.ttf',
//           bold: 'Carattere-Regular.ttf',
//           italics: 'Carattere-Regular.ttf',
//           bolditalics: 'Carattere-Regular.ttf',
//         },
//         OldEnglishTexTmt: {
//           normal: 'oldenglishtextmt.ttf',
//           bold: 'oldenglishtextmt.ttf',
//           italics: 'oldenglishtextmt.ttf',
//           bolditalics: 'oldenglishtextmt.ttf',
//         },
//         Calibri: {
//           normal: 'calibri-regular.ttf',
//           bold: 'calibri-bold.ttf',
//           italics: 'calibri-italic.ttf',
//           bolditalics: 'calibri-bold-italic.ttf',
//         },
//       };

//       const documentDefinition: any = {
//         pageSize: 'A4',
//         pageMargins: [40, 40, 40, 40],

//         background: [
//           {
//             image: 'bgImage',
//             width: 595,
//             height: 842,
//             absolutePosition: { x: 0, y: 0 },
//           },
//         ],

//         content: [
//           {
//             text: 'Government of the People’s Republic of Bangladesh',
//             style: 'header',
//           },
//           {
//             text: data.officeNameEnglish,
//             style: 'subheaderGreen',
//           },
//           {
//             text: 'NATIONAL SKILLS DEVELOPMENT AUTHORITY (NSDA)',
//             style: 'subheader',
//           },
//           {
//             text:
//               data.isCompetent == true
//                 ? 'National Skills Certificate'
//                 : 'Statement of Achievement',
//             style: 'certificateTitle',
//           },
//           {
//             text: 'on',
//             style: 'labelOn',
//           },
//           {
//             text: data.duration
//               ? `${data.certificateName}` //(${data.duration} hours)
//               : data.certificateName,
//             style: 'courseTitle',
//           },
//           {
//             text: '[Under the Bangladesh National Qualification Framework (BNQF)]',
//             style: 'bnqfHeader',
//           },
//           {
//             text: 'is awarded to',
//             style: 'labelIsAwardedTo',
//           },
//           {
//             text: data.participantName,
//             style: 'participantName',
//           },

//           {
//             text: [
//               `Father's Name: `,
//               {
//                 text: data.fatherNameEnglish,
//                 style: 'fatherMotherNidDynamicValue',
//               },
//               `, Mother's Name: `,
//               {
//                 text: data.motherNameEnglish,
//                 style: 'fatherMotherNidDynamicValue',
//               },
//               `, National ID/Birth Registration No: `,
//               {
//                 text: data.nidEnglish || 'Not Provided',
//                 style: 'fatherMotherNidDynamicValue',
//               },
//               ` for successfully completing the requirements of the following units of competency:`,
//             ],
//             style: 'participantDetails',
//           },

//           {
//             absolutePosition: { x: 70, y: 490 },
//             width: 520,
//             height: 200,
//             margin: [0, 15, 0, 10],
//             columns: (() => {
//               const allItems = data.competencyList
//                 ? data.competencyList
//                     .split('\n')
//                     .filter((item: string) => item.trim() !== '')
//                     .sort((a: string, b: string) => a.localeCompare(b))
//                 : [];

//               const UoC = allItems.length;

//               const allShort37 = allItems.every((x: string | any[]) => x.length <= 37);
//               const allShort79 = allItems.every((x: string | any[]) => x.length <= 79);
//               const hasLong = allItems.some((x: string | any[]) => x.length >= 79);

//               // FORMATTER
//               const formatItem = (text: string) => ({
//                 columns: [
//                   { image: checkIconBase64, width: 8, margin: [0, 0, 5, 0] },
//                   {
//                     text,
//                     style: 'competencyListEN',
//                     noWrap: false,
//                     width: '*',
//                   },
//                 ],
//                 margin: [0, 2, 2, 2],
//                 columnGap: 5,
//               });

//               const formatList = (arr: string[]) => arr.map(formatItem);

//               //CONDITION 1: UoC < 13 AND ALL items <= 37 chars
//               if (UoC <= 13 && allShort37) {
//                 return [{ stack: formatList(allItems), width: '100%' }];
//               }

//               //CONDITION 2: UoC < 13 AND ALL items <= 75 chars
//               if (UoC <= 13 && allShort79) {
//                 return [{ stack: formatList(allItems), width: '100%' }];
//               }

//               //CONDITION 3: UoC > 13 AND ALL items <= 37 chars (two columns)
//               if (UoC > 13 && allShort37) {
//                 const mid = Math.ceil(UoC / 2);
//                 return [
//                   { stack: formatList(allItems.slice(0, mid)), width: '50%' },
//                   { stack: formatList(allItems.slice(mid)), width: '50%' },
//                 ];
//               }

//               const estimateHeight = (text: string): number => {
//                 const avgCharsPerLine = 65;
//                 const baseHeight = 13;
//                 const lines = Math.ceil(text.length / avgCharsPerLine);
//                 return baseHeight * lines;
//               };

//               const totalHeight = allItems.reduce(
//                 (sum: number, item: string) => sum + estimateHeight(item),
//                 0
//               );

//               let availableHeight = totalHeight > 170 ? 150 : 170;

//               const firstColumn: string[] = [];
//               const secondColumn: string[] = [];
//               let currentHeight = 0;

//               if (totalHeight > availableHeight) {
//                 for (const item of allItems) {
//                   const itemHeight = estimateHeight(item);
//                   if (currentHeight + itemHeight > availableHeight) {
//                     secondColumn.push(item);
//                   } else {
//                     firstColumn.push(item);
//                     currentHeight += itemHeight;
//                   }
//                 }
//               } else {
//                 firstColumn.push(...allItems);
//               }

//               return secondColumn.length > 0
//                 ? [
//                     { stack: formatList(firstColumn), width: '50%' },
//                     { stack: formatList(secondColumn), width: '50%' },
//                   ]
//                 : [{ stack: formatList(firstColumn), width: '100%' }];
//             })(),
//             columnGap: 15,
//           },
//           {
//             absolutePosition: { x: 30, y: 720 },
//             columns: [
//               {
//                 stack: [
//                   {
//                     table: {
//                       widths: ['auto', 'auto'],
//                       body: [
//                         [
//                           {
//                             text: 'Serial No.',
//                             style: 'footerLeftStatic',
//                           },
//                           {
//                             text: `: ${data.serialNo}`,
//                             style: 'footerLeftDynamic',
//                           },
//                         ],
//                         [
//                           {
//                             text: 'Registration No.',
//                             style: 'footerLeftStatic',
//                           },
//                           {
//                             text: `: ${data.registrationNo}`,
//                             style: 'footerLeftDynamic',
//                           },
//                         ],
//                         [
//                           {
//                             text: 'Result Published On',
//                             style: 'footerLeftStatic',
//                           },
//                           {
//                             text: `: ${data.resultPublishedOn}`,
//                             style: 'footerLeftDynamic',
//                           },
//                         ],
//                         [
//                           {
//                             text: 'Valid until',
//                             style: 'footerLeftStatic',
//                           },
//                           {
//                             text: `: ${data.validUntil}`,
//                             style: 'footerLeftDynamic',
//                           },
//                         ],
//                       ],
//                     },
//                     layout: 'noBorders',
//                   },
//                 ],
//                 width: '48%',
//               },

//               {
//                 image: `data:image/png;base64,${data.imageStringQR}`,
//                 width: 80,
//                 alignment: 'center',
//                 margin: [10, -9, 10, 0],
//               },

//               {
//                 width: '35%',
//                 stack: [
//                   {
//                     image: chairmanSignatureBase64,
//                     width: 80,
//                     height: 30,
//                     alignment: 'center',
//                     margin: [0, 0, 0, 5],
//                   },
//                   {
//                     text: data.chairmanEnglishName,
//                     style: 'chairmanNameEN',
//                   },
//                   {
//                     text: data.chairmanEnglishDesignation,
//                     style: 'chairmanTextEN',
//                   },
//                 ],
//               },
//             ],
//             margin: [0, 10, 0, 0], // Adjust spacing
//           },

//           // Second Page: Bangla Content
//           { text: '', pageBreak: 'before' }, // Creates a new page
//           {
//             text: 'গণপ্রজাতন্ত্রী বাংলাদেশ সরকার',
//             style: 'headerBN',
//           },
//           {
//             text: data.officeNameBangla,
//             style: 'subheaderGreenBN',
//           },
//           {
//             text: 'জাতীয় দক্ষতা উন্নয়ন কর্তৃপক্ষ (এনএসডিএ)',
//             style: 'subheaderBN',
//           },
//           {
//             text:
//               data.isCompetent == true
//                 ? 'জাতীয় দক্ষতা সনদ'
//                 : 'স্টেটমেন্ট অব অ্যাচিভমেন্ট',
//             style: 'certificateTitleBN',
//           },
//           {
//             text: '',
//             style: 'labelOnBN',
//           },
//           {
//             text: data.durationBangla
//               ? `${data.certificateNameBangla}` //(${data.durationBangla} ঘন্টা)
//               : data.certificateNameBangla,
//             style: 'courseTitleBN',
//           },
//           {
//             text: '[বাংলাদেশ ন্যাশনাল কোয়ালিফিকেশন ফ্রেমওয়ার্ক (বিএনকিউএফ) এর আওতায়]',
//             style: 'bnqfHeaderBN',
//           },
//           {
//             text: '',
//             style: 'labelIsAwardedToBN',
//           },
//           {
//             text: data.participantNameBangla,
//             style: 'participantNameBN',
//           },

//           {
//             text: [
//               ` পিতা: `,
//               {
//                 text: data.fatherNameBangla,
//                 style: 'fatherMotherNidDynamicValueBN',
//               },
//               `, মাতা: `,
//               {
//                 text: data.motherNameBangla,
//                 style: 'fatherMotherNidDynamicValueBN',
//               },
//               `, জাতীয় পরিচয়পত্র / জন্ম নিবন্ধন নম্বর: `,
//               {
//                 text: data.nidBangla || 'Not Provided',
//                 style: 'fatherMotherNidDynamicValueBN',
//               },
//               `-কে নিম্নোক্ত কম্পিটেন্সি ইউনিটসমূহ সফলভাবে সম্পন্ন করায়, জাতীয় দক্ষতা সনদ প্রদান করা হলো:`,
//             ],
//             style: 'participantDetailsBN',
//           },

//           {
//             absolutePosition: { x: 70, y: 480 },
//             width: 520,
//             height: 200,
//             margin: [0, 15, 0, 10],
//             columns: (() => {
//               const allItems = data.competencyList
//                 ? data.competencyList
//                     .split('\n')
//                     .filter((item: string) => item.trim() !== '')
//                     .sort((a: string, b: string) => a.localeCompare(b))
//                 : [];

//               const UoC = allItems.length;

//               const allShort37 = allItems.every((x: string | any[]) => x.length <= 37);
//               const allShort79 = allItems.every((x: string | any[]) => x.length <= 79);
//               const hasLong = allItems.some((x: string | any[]) => x.length >= 77);

//               // FORMATTER
//               const formatItem = (text: string) => ({
//                 columns: [
//                   { image: checkIconBase64, width: 8, margin: [0, -4, 5, 0] },
//                   {
//                     text,
//                     style: 'competencyListBN',
//                     noWrap: false,
//                     width: '*',
//                   },
//                 ],
//                 margin: [0, 2, 2, 2],
//                 columnGap: 5,
//               });

//               const formatList = (arr: string[]) => arr.map(formatItem);

//               //CONDITION 1: UoC < 13 AND ALL items <= 37 chars
//               if (UoC <= 13 && allShort37) {
//                 return [{ stack: formatList(allItems), width: '100%' }];
//               }

//               //CONDITION 2: UoC < 13 AND ALL items <= 75 chars
//               if (UoC <= 13 && allShort79) {
//                 return [{ stack: formatList(allItems), width: '100%' }];
//               }

//               //CONDITION 3: UoC > 13 AND ALL items <= 37 chars (two columns)
//               if (UoC > 13 && allShort37) {
//                 const mid = Math.ceil(UoC / 2);
//                 return [
//                   { stack: formatList(allItems.slice(0, mid)), width: '50%' },
//                   { stack: formatList(allItems.slice(mid)), width: '50%' },
//                 ];
//               }

//               const estimateHeight = (text: string): number => {
//                 const avgCharsPerLine = 65;
//                 const baseHeight = 13;
//                 const lines = Math.ceil(text.length / avgCharsPerLine);
//                 return baseHeight * lines;
//               };

//               const totalHeight = allItems.reduce(
//                 (sum: number, item: string) => sum + estimateHeight(item),
//                 0
//               );

//               let availableHeight = totalHeight > 170 ? 150 : 170;

//               const firstColumn: string[] = [];
//               const secondColumn: string[] = [];
//               let currentHeight = 0;

//               if (totalHeight > availableHeight) {
//                 for (const item of allItems) {
//                   const itemHeight = estimateHeight(item);
//                   if (currentHeight + itemHeight > availableHeight) {
//                     secondColumn.push(item);
//                   } else {
//                     firstColumn.push(item);
//                     currentHeight += itemHeight;
//                   }
//                 }
//               } else {
//                 firstColumn.push(...allItems);
//               }

//               return secondColumn.length > 0
//                 ? [
//                     { stack: formatList(firstColumn), width: '50%' },
//                     { stack: formatList(secondColumn), width: '50%' },
//                   ]
//                 : [{ stack: formatList(firstColumn), width: '100%' }];
//             })(),
//             columnGap: 15,
//           },
//           {
//             absolutePosition: { x: 30, y: 720 },
//             columns: [
//               {
//                 stack: [
//                   {
//                     table: {
//                       widths: ['auto', 'auto'],
//                       body: [
//                         [
//                           {
//                             text: 'ক্রমিক নম্বর',
//                             style: 'footerLeftStaticBN',
//                           },
//                           {
//                             text: `: ${data.serialNo}`,
//                             style: 'footerLeftDynamic',
//                           },
//                         ],
//                         [
//                           {
//                             text: 'রেজিস্ট্রেশন নম্বর',
//                             style: 'footerLeftStaticBN',
//                           },
//                           {
//                             text: `: ${data.registrationNo}`,
//                             style: 'footerLeftDynamic',
//                           },
//                         ],
//                         [
//                           {
//                             text: 'ফলাফল প্রকাশের তারিখ',
//                             style: 'footerLeftStaticBN',
//                           },
//                           {
//                             text: `: ${data.resultPublishedOnBangla}`,
//                             style: 'footerLeftDynamicBN',
//                           },
//                         ],
//                         [
//                           {
//                             text: 'মেয়াদোত্তীর্ণের তারিখ',
//                             style: 'footerLeftStaticBN',
//                           },
//                           {
//                             text: `: ${data.validUntilBangla}`,
//                             style: 'footerLeftDynamicBN',
//                           },
//                         ],
//                       ],
//                     },
//                     layout: 'noBorders',
//                   },
//                 ],
//                 width: '48%',
//               },

//               {
//                 image: `data:image/png;base64,${data.imageStringQR}`,
//                 width: 80,
//                 alignment: 'center',
//                 margin: [10, -9, 10, 0],
//               },

//               {
//                 width: '35%',
//                 stack: [
//                   {
//                     image: chairmanSignatureBase64,
//                     width: 80,
//                     height: 30,
//                     alignment: 'center',
//                     margin: [0, 0, 0, 5],
//                   },
//                   {
//                     text: data.chairmanBanglaName,
//                     style: 'chairmanNameBN',
//                   },
//                   {
//                     text: data.chairmanBanglaDesignation,
//                     style: 'chairmanTextBN',
//                   },
//                 ],
//               },
//             ],
//             margin: [0, 10, 0, 0], // Adjust spacing
//           },
//         ],

//         images: {
//           bgImage: bgImageBase64,
//           checkIcon: checkIconBase64,
//           chairmanSignature: chairmanSignatureBase64,
//         },

//         styles: {
//           //English
//           header: {
//             fontSize: 17,
//             alignment: 'center',
//             margin: [0, 114, 0, 10],
//           },
//           subheader: {
//             fontSize: 12,
//             bold: true,
//             alignment: 'center',
//             margin: [0, 0, 0, 10],
//           },
//           subheaderGreen: {
//             fontSize: 29,
//             font: 'Calibri',
//             bold: true,
//             alignment: 'center',
//             color: 'green',
//             margin: [0, -3, 0, 10],
//           },
//           certificateTitle: {
//             fontSize: 25,
//             font: 'Calibri',
//             bold: true,
//             alignment: 'center',
//             margin: [0, 20, 0, 0],
//           },
//           labelOn: {
//             fontSize: 12,
//             font: 'Carattere',
//             italics: true,
//             alignment: 'center',
//             margin: [0, 5, 0, 0],
//           },
//           bnqfHeader: {
//             fontSize: 12,
//             font: 'Roboto',
//             alignment: 'center',
//             margin: [0, 5, 0, 0],
//           },
//           labelIsAwardedTo: {
//             fontSize: 12,
//             font: 'Carattere',
//             italics: true,
//             alignment: 'center',
//             margin: [0, 23, 0, 0],
//           },
//           courseTitle: {
//             fontSize: 16,
//             alignment: 'center',
//             margin: [0, 5, 0, 0],
//           },
//           participantName: {
//             fontSize: 25,
//             // font: 'OldEnglishTexTmt',
//             bold: true,
//             alignment: 'center',
//             margin: [0, 5, 0, 10],
//           },
//           fatherMotherNidDynamicValue: {
//             // font: 'OldEnglishTexTmt',
//             // italics: true,
//             //bold: true,
//           },
//           participantDetails: {
//             fontSize: 11,
//             alignment: 'center',
//             margin: [10, 0, 10, 0],
//             lineHeight: 1.5,
//           },
//           competencyListEN: {
//             font: 'Roboto',
//             italics: true,
//             fontSize: 10,
//             lineHeight: 1.2,
//             margin: [0, -2, 0, 0],
//           },
//           footerLeftStatic: {
//             fontSize: 11,
//             alignment: 'left',
//             font: 'Carattere',
//             bold: true,
//             margin: [25, 0, -7, 0],
//           },
//           footerLeftDynamic: { fontSize: 9, alignment: 'left', italics: true },
//           chairmanNameEN: {
//             fontSize: 11,
//             alignment: 'center',
//             font: 'Carattere',
//             bold: true,
//             margin: [0, 2, 0, 2],
//           },
//           chairmanTextEN: {
//             fontSize: 12,
//             alignment: 'center',
//             font: 'Carattere',
//             bold: true,
//             margin: [0, 0, 0, 0],
//           },

//           //Bangla
//           headerBN: {
//             font: 'NikoshBAN',
//             fontSize: 28,
//             bold: true,
//             alignment: 'center',
//             margin: [0, 114, 0, 10],
//           },
//           subheaderBN: {
//             font: 'NikoshBAN',
//             fontSize: 22,
//             bold: true,
//             alignment: 'center',
//             margin: [0, -10, 0, 10],
//           },
//           subheaderGreenBN: {
//             font: 'NikoshBAN',
//             fontSize: 30,
//             bold: true,
//             alignment: 'center',
//             color: 'green',
//             margin: [0, -12, 0, 10],
//           },
//           certificateTitleBN: {
//             font: 'NikoshBAN',
//             fontSize: 28,
//             bold: true,
//             alignment: 'center',
//             margin: [0, 20, 0, 0],
//           },
//           labelOnBN: {
//             font: 'NikoshBAN',
//             fontSize: 12,
//             italics: true,
//             bold: true,
//             alignment: 'center',
//             margin: [0, 5, 0, 0],
//           },
//           bnqfHeaderBN: {
//             fontSize: 12,
//             font: 'NikoshBAN',
//             alignment: 'center',
//             margin: [0, 5, 0, 0],
//           },
//           labelIsAwardedToBN: {
//             font: 'NikoshBAN',
//             fontSize: 12,
//             italics: true,
//             bold: true,
//             alignment: 'center',
//             margin: [0, 23, 0, 0],
//           },
//           courseTitleBN: {
//             font: 'NikoshBAN',
//             fontSize: 23,
//             alignment: 'center',
//             margin: [0, -5, 0, 0],
//           },
//           participantNameBN: {
//             font: 'NikoshBAN',
//             fontSize: 20,
//             bold: true,
//             alignment: 'center',
//             margin: [0, 5, 0, 10],
//           },
//           fatherMotherNidDynamicValueBN: {
//             font: 'NikoshBAN',
//             italics: true,
//             //bold: true,
//           },
//           participantDetailsBN: {
//             font: 'NikoshBAN',
//             fontSize: 12,
//             alignment: 'center',
//             margin: [10, 0, 10, 0],
//             lineHeight: 1.5,
//           },
//           competencyListBN: {
//             font: 'Roboto',
//             italics: true,
//             fontSize: 10,
//             lineHeight: 1.5,
//             margin: [0, -6, 0, 0],
//           },
//           footerLeftStaticBN: {
//             font: 'NikoshBAN',
//             fontSize: 11,
//             alignment: 'left',
//             bold: true,
//             margin: [25, 0, -7, 0],
//           },
//           footerLeftDynamicBN: {
//             font: 'NikoshBAN',
//             fontSize: 9,
//             alignment: 'left',
//             italics: true,
//           },
//           chairmanNameBN: {
//             font: 'NikoshBAN',
//             fontSize: 11,
//             alignment: 'center',
//             bold: true,
//             margin: [0, 2, 0, 2],
//           },
//           chairmanTextBN: {
//             font: 'NikoshBAN',
//             fontSize: 12,
//             alignment: 'center',
//             bold: true,
//             margin: [0, 0, 0, 0],
//           },
//         },
//       };

//       pdfMake
//         .createPdf(documentDefinition)
//         .download(`Certificate_${data.participantName}.pdf`);
//     } catch (error) {
//       console.error('Error loading images:', error);
//     }
//   }

//   async getChairmanImageBase64(fileUrl: string): Promise<string> {
//     try {
//       const response = await fetch(environment.fileServiceApiUrl + fileUrl);
//       const blob = await response.blob();
//       return await this.convertBlobToBase64(blob);
//     } catch (error) {
//       console.error('Error fetching image:', error);
//       throw error;
//     }
//   }

//   convertBlobToBase64(blob: Blob): Promise<string> {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.readAsDataURL(blob);
//       reader.onloadend = () => resolve(reader.result as string);
//       reader.onerror = (error) => reject(error);
//     });
//   }

//   getBase64ImageFromURL(url: any) {
//     return new Promise((resolve, reject) => {
//       var img = new Image();
//       img.setAttribute('crossOrigin', 'anonymous');

//       img.onload = () => {
//         var canvas = document.createElement('canvas');
//         canvas.width = img.width;
//         canvas.height = img.height;

//         var ctx: any | null = canvas.getContext('2d');
//         ctx.drawImage(img, 0, 0);

//         var dataURL = canvas.toDataURL('image/png');

//         resolve(dataURL);
//       };

//       img.onerror = (error) => {
//         reject(error);
//       };

//       img.src = url;
//     });
//   }

//   async loadFontToVFS(fontUrl: string, fontName: string) {
//     const response = await fetch(fontUrl);
//     const fontBlob = await response.blob();
//     const reader = new FileReader();

//     return new Promise((resolve) => {
//       reader.onloadend = () => {
//         const base64Font = (reader.result as string).split(',')[1]; // Get the Base64 part
//         (pdfMake as any).vfs[`${fontName}.ttf`] = base64Font; // Store font in vfs
//         resolve(true);
//       };
//       reader.readAsDataURL(fontBlob);
//     });
//   }

//   async onDownloadSTPCertificate(data: any) {
//     try {
//       const bgImageBase64 = await this.getBase64ImageFromURL(
//         '/assets/certificate/new_certificate_files_by_pdf_make/bg_stp.jpg'
//       );

//       let fileUrl = data.chairmanSignatureFilePath;
//       let chairmanSignatureBase64 = await this.getChairmanImageBase64(fileUrl);

//       await this.loadFontToVFS('/assets/fonts/NikoshBAN.ttf', 'NikoshBAN');
//       await this.loadFontToVFS(
//         '/assets/fonts/Carattere/Carattere-Regular.ttf',
//         'Carattere-Regular'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Century-Schoolbook/CENSCBK.ttf',
//         'CENSCBK'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Century-Schoolbook/SCHLBKB.ttf',
//         'SCHLBKB'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Edwardian-Script/edwardianscriptitc.ttf',
//         'edwardianscriptitc'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Edwardian-Script/edwardian-script-itc-bold.ttf',
//         'edwardianscriptitcb'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Old-English-Text-MT/oldenglishtextmt.ttf',
//         'oldenglishtextmt'
//       );

//       await this.loadFontToVFS(
//         '/assets/fonts/Calibri/calibri-bold-italic.ttf',
//         'calibri-bold-italic'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Calibri/calibri-bold.ttf',
//         'calibri-bold'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Calibri/calibri-italic.ttf',
//         'calibri-italic'
//       );
//       await this.loadFontToVFS(
//         '/assets/fonts/Calibri/calibri-regular.ttf',
//         'calibri-regular'
//       );

//       (pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
//       (pdfMake as any).fonts = {
//         NikoshBAN: {
//           normal: 'NikoshBAN.ttf',
//           bold: 'NikoshBAN.ttf',
//           italics: 'NikoshBAN.ttf',
//           bolditalics: 'NikoshBAN.ttf',
//         },
//         Roboto: {
//           normal: 'Roboto-Regular.ttf',
//           bold: 'Roboto-Medium.ttf',
//           italics: 'Roboto-Italic.ttf',
//           bolditalics: 'Roboto-MediumItalic.ttf',
//         },
//         EdwardianScriptItc: {
//           normal: 'edwardianscriptitc.ttf',
//           bold: 'edwardianscriptitcb.ttf',
//           italics: 'edwardianscriptitc.ttf',
//           bolditalics: 'edwardianscriptitc.ttf',
//         },
//         Carattere: {
//           normal: 'Carattere-Regular.ttf',
//           bold: 'Carattere-Regular.ttf',
//           italics: 'Carattere-Regular.ttf',
//           bolditalics: 'Carattere-Regular.ttf',
//         },
//         CENSCBK: {
//           normal: 'CENSCBK.ttf',
//           bold: 'SCHLBKB.ttf',
//           italics: 'CENSCBK.ttf',
//           bolditalics: 'SCHLBKB.ttf',
//         },
//         OldEnglishTexTmt: {
//           normal: 'oldenglishtextmt.ttf',
//           bold: 'oldenglishtextmt.ttf',
//           italics: 'oldenglishtextmt.ttf',
//           bolditalics: 'oldenglishtextmt.ttf',
//         },
//         Calibri: {
//           normal: 'calibri-regular.ttf',
//           bold: 'calibri-bold.ttf',
//           italics: 'calibri-italic.ttf',
//           bolditalics: 'calibri-bold-italic.ttf',
//         },
//       };

//       const documentDefinition: any = {
//         pageSize: 'A4',
//         pageMargins: [40, 40, 40, 40],

//         background: [
//           {
//             image: 'bgImage',
//             width: 595,
//             height: 842,
//             absolutePosition: { x: 0, y: 0 },
//           },
//         ],

//         content: [
//           {
//             text: 'Government of the People’s Republic of Bangladesh',
//             style: 'header',
//           },
//           {
//             text: data.officeNameEnglish,
//             style: 'subheaderGreen',
//           },
//           {
//             text: 'NATIONAL SKILLS DEVELOPMENT AUTHORITY (NSDA)',
//             style: 'subheader',
//           },
//           {
//             text: 'Certificate of Registration',
//             style: 'certificateTitle',
//           },
//           {
//             text: data.stpName,
//             style: 'stpName',
//           },

//           {
//             text: 'is registered as a Skills Training Provider under section 16(1) of NSDA Act, 2018.',
//             style: 'details',
//           },
//           {
//             absolutePosition: { x: 30, y: 680 },
//             columns: [
//               {
//                 stack: [
//                   {
//                     table: {
//                       widths: ['auto', 'auto'],
//                       body: [
//                         [
//                           {
//                             text: 'Registration No.',
//                             style: 'footerLeftStatic',
//                           },
//                           {
//                             text: `: ${data.registrationNo}`,
//                             style: 'footerLeftDynamic',
//                           },
//                         ],
//                         [
//                           {
//                             text: 'Issued on',
//                             style: 'footerLeftStatic',
//                           },
//                           {
//                             text: `: ${data.issuedOn}`,
//                             style: 'footerLeftDynamic',
//                           },
//                         ],
//                         [
//                           {
//                             text: 'Valid until',
//                             style: 'footerLeftStatic',
//                           },
//                           {
//                             text: `: ${data.validUntil}`,
//                             style: 'footerLeftDynamic',
//                           },
//                         ],
//                       ],
//                     },
//                     layout: 'noBorders',
//                   },
//                 ],
//                 width: '48%',
//               },

//               {
//                 image: `data:image/png;base64,${data.qrImageString}`,
//                 width: 80,
//                 alignment: 'center',
//                 margin: [10, -20, 10, 0],
//               },

//               {
//                 width: '35%',
//                 stack: [
//                   {
//                     image: chairmanSignatureBase64,
//                     width: 80,
//                     height: 30,
//                     alignment: 'center',
//                     margin: [0, -15, 0, 5],
//                   },
//                   {
//                     text: data.chairmanEnglishName,
//                     style: 'chairmanNameEN',
//                   },
//                   {
//                     text: data.chairmanEnglishDesignation,
//                     style: 'chairmanTextEN',
//                   },
//                 ],
//               },
//             ],
//             margin: [0, 10, 0, 0], // Adjust spacing
//           },

//           // Second Page: Bangla Content
//           { text: '', pageBreak: 'before' }, // Creates a new page
//           {
//             text: 'গণপ্রজাতন্ত্রী বাংলাদেশ সরকার',
//             style: 'headerBN',
//           },
//           {
//             text: data.officeNameBangla,
//             style: 'subheaderGreenBN',
//           },
//           {
//             text: 'জাতীয় দক্ষতা উন্নয়ন কর্তৃপক্ষ (এনএসডিএ)',
//             style: 'subheaderBN',
//           },
//           {
//             text: 'নিবন্ধন সনদ',
//             style: 'certificateTitleBN',
//           },
//           {
//             text: data.stpNameBangla,
//             style: 'stpNameBN',
//           },

//           {
//             text: 'জাতীয় দক্ষতা উন্নয়ন কর্তৃপক্ষ আইন, ২০১৮ এর অনুচ্ছেদ ১৬(১) অনুযায়ী দক্ষতা প্রশিক্ষণ প্রতিষ্ঠান হিসেবে নিবন্ধন প্রদান করা হলো।',
//             style: 'detailsBN',
//           },
//           {
//             absolutePosition: { x: 30, y: 680 },
//             columns: [
//               {
//                 stack: [
//                   {
//                     table: {
//                       widths: ['auto', 'auto'],
//                       body: [
//                         [
//                           {
//                             text: 'নিবন্ধন নম্বর',
//                             style: 'footerLeftStaticBN',
//                           },
//                           {
//                             text: `: ${data.registrationNo}`,
//                             style: 'footerLeftDynamic',
//                           },
//                         ],
//                         [
//                           {
//                             text: 'ইস্যুর তারিখ',
//                             style: 'footerLeftStaticBN',
//                           },
//                           {
//                             text: `: ${data.issuedOn}`,
//                             style: 'footerLeftDynamicBN',
//                           },
//                         ],
//                         [
//                           {
//                             text: 'মেয়াদোত্তীর্ণের তারিখ',
//                             style: 'footerLeftStaticBN',
//                           },
//                           {
//                             text: `: ${data.validUntilBangla}`,
//                             style: 'footerLeftDynamicBN',
//                           },
//                         ],
//                       ],
//                     },
//                     layout: 'noBorders',
//                   },
//                 ],
//                 width: '48%',
//               },

//               {
//                 image: `data:image/png;base64,${data.qrImageString}`,
//                 width: 80,
//                 alignment: 'center',
//                 margin: [10, -20, 10, 0],
//               },

//               {
//                 width: '35%',
//                 stack: [
//                   {
//                     image: chairmanSignatureBase64,
//                     width: 80,
//                     height: 30,
//                     alignment: 'center',
//                     margin: [0, -15, 0, 5],
//                   },
//                   {
//                     text: data.chairmanBanglaName,
//                     style: 'chairmanNameBN',
//                   },
//                   {
//                     text: data.chairmanBanglaDesignation,
//                     style: 'chairmanTextBN',
//                   },
//                 ],
//               },
//             ],
//             margin: [0, 10, 0, 0], // Adjust spacing
//           },
//         ],

//         images: {
//           bgImage: bgImageBase64,
//           chairmanSignature: chairmanSignatureBase64,
//         },

//         styles: {
//           //English
//           header: {
//             fontSize: 17,
//             alignment: 'center',
//             margin: [0, 140, 0, 10],
//           },
//           subheader: {
//             fontSize: 12,
//             bold: true,
//             alignment: 'center',
//             margin: [0, 0, 0, 0],
//           },
//           subheaderGreen: {
//             fontSize: 29,
//             font: 'Calibri',
//             bold: true,
//             alignment: 'center',
//             color: 'green',
//             margin: [0, -3, 0, 10],
//           },
//           certificateTitle: {
//             fontSize: 25,
//             font: 'Calibri',
//             bold: true,
//             alignment: 'center',
//             margin: [0, 80, 0, 0],
//           },
//           stpName: {
//             fontSize: 25,
//             font: 'Roboto',
//             bold: true,
//             alignment: 'center',
//             margin: [0, 45, 0, 10],
//           },
//           details: {
//             font: 'CENSCBK',
//             fontSize: 18,
//             alignment: 'center',
//             margin: [50, 0, 50, 0],
//             lineHeight: 1.5,
//           },
//           footerLeftStatic: {
//             fontSize: 11,
//             alignment: 'left',
//             font: 'Carattere',
//             bold: true,
//             margin: [40, 0, -7, 0],
//           },
//           footerLeftDynamic: { fontSize: 9, alignment: 'left', italics: true },
//           chairmanNameEN: {
//             fontSize: 11,
//             alignment: 'center',
//             font: 'Carattere',
//             bold: true,
//             margin: [0, 2, 0, 2],
//           },
//           chairmanTextEN: {
//             fontSize: 12,
//             alignment: 'center',
//             font: 'Carattere',
//             bold: true,
//             margin: [0, 0, 0, 0],
//           },

//           //Bangla
//           headerBN: {
//             font: 'NikoshBAN',
//             fontSize: 28,
//             bold: true,
//             alignment: 'center',
//             margin: [0, 140, 0, 10],
//           },
//           subheaderBN: {
//             font: 'NikoshBAN',
//             fontSize: 22,
//             bold: true,
//             alignment: 'center',
//             margin: [0, -10, 0, 0],
//           },
//           subheaderGreenBN: {
//             font: 'NikoshBAN',
//             fontSize: 30,
//             bold: true,
//             alignment: 'center',
//             color: 'green',
//             margin: [0, -12, 0, 10],
//           },
//           certificateTitleBN: {
//             font: 'NikoshBAN',
//             fontSize: 32,
//             bold: true,
//             alignment: 'center',
//             margin: [0, 65, 0, 0],
//           },
//           stpNameBN: {
//             font: 'NikoshBAN',
//             fontSize: 28,
//             bold: true,
//             alignment: 'center',
//             margin: [0, 45, 0, 10],
//           },
//           detailsBN: {
//             font: 'NikoshBAN',
//             fontSize: 17,
//             alignment: 'center',
//             margin: [50, 0, 50, 0],
//             lineHeight: 1.5,
//           },
//           footerLeftStaticBN: {
//             font: 'NikoshBAN',
//             fontSize: 11,
//             alignment: 'left',
//             bold: true,
//             margin: [40, 0, -7, 0],
//           },
//           footerLeftDynamicBN: {
//             font: 'NikoshBAN',
//             fontSize: 9,
//             alignment: 'left',
//             italics: true,
//           },
//           chairmanNameBN: {
//             font: 'NikoshBAN',
//             fontSize: 11,
//             alignment: 'center',
//             bold: true,
//             margin: [0, 2, 0, 2],
//           },
//           chairmanTextBN: {
//             font: 'NikoshBAN',
//             fontSize: 12,
//             alignment: 'center',
//             bold: true,
//             margin: [0, 0, 0, 0],
//           },
//         },
//       };

//       pdfMake
//         .createPdf(documentDefinition)
//         .download(`Certificate_${data.stpName}.pdf`);
//     } catch (error) {
//       console.error('Error loading images:', error);
//     }
//   }

//   splitCompetencyList(list: string[], maxPerColumn: number) {
//     const firstColumn = list.slice(0, maxPerColumn);
//     const secondColumn = list.slice(maxPerColumn);
//     return { firstColumn, secondColumn };
//   }
// }



import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ServerResponse } from '../models/dto/server-response.dto';
import { RplStorageService } from 'src/app/modules/stp-operations/services/rpl-storage.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

@Injectable({
  providedIn: 'root',
})
export class CertificateService {
  constructor(
    private rplStorageService: RplStorageService,
    private notification: NzNotificationService
  ) {}

  // rpl batch
  fetchDataFromTCIAndDownloadCertificateRPL(data: any) {
    this.rplStorageService.downloadCertificateForRpl(data).subscribe({
      next: (response: ServerResponse) => {
        if (!response?.success) {
          this.notification.error(
            'Error',
            response?.message || 'Something went wrong!'
          );
          return;
        }
        this.onCertificateDownloadRPL(response.data);
      },
      error: (error: any) => {
        console.error('API Error:', error);
        this.notification.error(
          'Error',
          'Certificate download failed due to missing or incomplete data. Please try again.'
        );
      },
    });
  }

    // regular batch
  fetchDataFromTCIAndDownloadCertificate(data: any) {
    this.rplStorageService.downloadCertificateForRpl(data).subscribe({
      next: (response: ServerResponse) => {
        if (!response?.success) {
          this.notification.error(
            'Error',
            response?.message || 'Something went wrong!'
          );
          return;
        }
        this.onCertificateDownloadREG(response.data);
      },
      error: (error: any) => {
        console.error('API Error:', error);
        this.notification.error(
          'Error',
          'Certificate download failed due to missing or incomplete data. Please try again.'
        );
      },
    });
  }

  async onFreelancerCertificateDownload(data: any) {
    try {
      const bgImageBase64 = await this.getBase64ImageFromURL(
        '/assets/certificate/new_certificate_files_by_pdf_make/bg.jpg'
      );
      const checkIconBase64 = await this.getBase64ImageFromURL(
        '/assets/certificate/new_certificate_files_by_pdf_make/green-check-mark.jpeg'
      );

      let fileUrl = data.tciCertificateInfoPayload.chairmanSignatureFilePath;
      let chairmanSignatureBase64 = await this.getChairmanImageBase64(fileUrl);

      await this.loadFontToVFS('/assets/fonts/NikoshBAN.ttf', 'NikoshBAN');
      await this.loadFontToVFS(
        '/assets/fonts/Carattere/Carattere-Regular.ttf',
        'Carattere-Regular'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Edwardian-Script/edwardianscriptitc.ttf',
        'edwardianscriptitc'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Edwardian-Script/edwardian-script-itc-bold.ttf',
        'edwardianscriptitcb'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Old-English-Text-MT/oldenglishtextmt.ttf',
        'oldenglishtextmt'
      );

      await this.loadFontToVFS(
        '/assets/fonts/Calibri/calibri-bold-italic.ttf',
        'calibri-bold-italic'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Calibri/calibri-bold.ttf',
        'calibri-bold'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Calibri/calibri-italic.ttf',
        'calibri-italic'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Calibri/calibri-regular.ttf',
        'calibri-regular'
      );

      (pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
      (pdfMake as any).fonts = {
        NikoshBAN: {
          normal: 'NikoshBAN.ttf',
          bold: 'NikoshBAN.ttf',
          italics: 'NikoshBAN.ttf',
          bolditalics: 'NikoshBAN.ttf',
        },
        Roboto: {
          normal: 'Roboto-Regular.ttf',
          bold: 'Roboto-Medium.ttf',
          italics: 'Roboto-Italic.ttf',
          bolditalics: 'Roboto-MediumItalic.ttf',
        },
        EdwardianScriptItc: {
          normal: 'edwardianscriptitc.ttf',
          bold: 'edwardianscriptitcb.ttf',
          italics: 'edwardianscriptitc.ttf',
          bolditalics: 'edwardianscriptitc.ttf',
        },
        Carattere: {
          normal: 'Carattere-Regular.ttf',
          bold: 'Carattere-Regular.ttf',
          italics: 'Carattere-Regular.ttf',
          bolditalics: 'Carattere-Regular.ttf',
        },
        OldEnglishTexTmt: {
          normal: 'oldenglishtextmt.ttf',
          bold: 'oldenglishtextmt.ttf',
          italics: 'oldenglishtextmt.ttf',
          bolditalics: 'oldenglishtextmt.ttf',
        },
        Calibri: {
          normal: 'calibri-regular.ttf',
          bold: 'calibri-bold.ttf',
          italics: 'calibri-italic.ttf',
          bolditalics: 'calibri-bold-italic.ttf',
        },
      };

      const documentDefinition: any = {
        pageSize: 'A4',
        pageMargins: [40, 40, 40, 40],

        background: [
          {
            image: 'bgImage',
            width: 595,
            height: 842,
            absolutePosition: { x: 0, y: 0 },
          },
        ],

        content: [
          {
            text: 'Government of the People’s Republic of Bangladesh',
            style: 'header',
          },
          {
            text: data.tciCertificateInfoPayload.officeNameEnglish,
            style: 'subheaderGreen',
          },
          {
            text: 'NATIONAL SKILLS DEVELOPMENT AUTHORITY (NSDA)',
            style: 'subheader',
          },
          {
            text: 'National Skills Certificate',
            style: 'certificateTitle',
          },
          {
            text: 'on',
            style: 'labelOn',
          },
          {
            text: data.tciCertificateInfoPayload.duration
              ? `${data.tciCertificateInfoPayload.certificateName} (${data.tciCertificateInfoPayload.duration} hours)`
              : data.tciCertificateInfoPayload.certificateName,
            style: 'courseTitle',
          },
          {
            text: '[Under the Bangladesh National Qualification Framework (BNQF)]',
            style: 'bnqfHeader',
          },
          {
            text: 'is awarded to',
            style: 'labelIsAwardedTo',
          },
          {
            text: data.tciCertificateInfoPayload.participantName,
            style: 'participantName',
          },

          {
            text: [
              `Father's Name: `,
              {
                text: data.tciCertificateInfoPayload.fatherNameEnglish,
                style: 'fatherMotherNidDynamicValue',
              },
              `, Mother's Name: `,
              {
                text: data.tciCertificateInfoPayload.motherNameEnglish,
                style: 'fatherMotherNidDynamicValue',
              },
              `, National ID/Birth Registration No: `,
              {
                text:
                  data.tciCertificateInfoPayload.nidEnglish || 'Not Provided',
                style: 'fatherMotherNidDynamicValue',
              },
              ` for successfully completing the requirements of the following units of competency:`,
            ],
            style: 'participantDetails',
          },

          {
            stack: data.tciCertificateInfoPayload.competencyList
              ? data.tciCertificateInfoPayload.competencyList
                  .split('\n')
                  .filter((item: string) => item.trim() !== '')
                  .sort((a: string, b: any) => a.localeCompare(b))
                  .map((item: string) => ({
                    columns: [
                      {
                        image: checkIconBase64,
                        width: 8,
                        margin: [0, 0, 5, 0],
                      },
                      {
                        text: item,
                        style: 'competencyListEN',
                      },
                    ],
                    columnGap: 5,
                    margin: [0, 2, 2, 2],
                  }))
              : [],
            margin: [30, 15, 0, 10],
          },
          {
            absolutePosition: { x: 30, y: 720 },
            columns: [
              {
                stack: [
                  {
                    table: {
                      widths: ['auto', 'auto'],
                      body: [
                        [
                          {
                            text: 'Serial No.',
                            style: 'footerLeftStatic',
                          },
                          {
                            text: `: ${data.tciCertificateInfoPayload.serialNo}`,
                            style: 'footerLeftDynamic',
                          },
                        ],
                        [
                          {
                            text: 'Registration No.',
                            style: 'footerLeftStatic',
                          },
                          {
                            text: `: ${data.tciCertificateInfoPayload.registrationNo}`,
                            style: 'footerLeftDynamic',
                          },
                        ],
                        [
                          {
                            text: 'Result Published On',
                            style: 'footerLeftStatic',
                          },
                          {
                            text: `: ${data.tciCertificateInfoPayload.resultPublishedOn}`,
                            style: 'footerLeftDynamic',
                          },
                        ],
                        [
                          {
                            text: 'Valid until',
                            style: 'footerLeftStatic',
                          },
                          {
                            text: `: ${data.tciCertificateInfoPayload.validUntil}`,
                            style: 'footerLeftDynamic',
                          },
                        ],
                      ],
                    },
                    layout: 'noBorders',
                  },
                ],
                width: '48%',
              },

              {
                image: `data:image/png;base64,${
                  data.imageStringQR
                    ? data.imageStringQR
                    : data.tciCertificateInfoPayload?.imageStringQR
                }`,
                width: 80,
                alignment: 'center',
                margin: [10, -9, 10, 0],
              },

              {
                width: '35%',
                stack: [
                  {
                    image: chairmanSignatureBase64,
                    width: 80,
                    height: 30,
                    alignment: 'center',
                    margin: [0, 0, 0, 5],
                  },
                  {
                    text: data.tciCertificateInfoPayload.chairmanEnglishName,
                    style: 'chairmanNameEN',
                  },
                  {
                    text: data.tciCertificateInfoPayload
                      .chairmanEnglishDesignation,
                    style: 'chairmanTextEN',
                  },
                ],
              },
            ],
            margin: [0, 10, 0, 0], // Adjust spacing
          },

          // Second Page: Bangla Content
          { text: '', pageBreak: 'before' }, // Creates a new page
          {
            text: 'গণপ্রজাতন্ত্রী বাংলাদেশ সরকার',
            style: 'headerBN',
          },
          {
            text: data.tciCertificateInfoPayload.officeNameBangla,
            style: 'subheaderGreenBN',
          },
          {
            text: 'জাতীয় দক্ষতা উন্নয়ন কর্তৃপক্ষ (এনএসডিএ)',
            style: 'subheaderBN',
          },
          {
            text: 'জাতীয় দক্ষতা সনদ',
            style: 'certificateTitleBN',
          },
          {
            text: '',
            style: 'labelOnBN',
          },
          {
            text: data.tciCertificateInfoPayload.durationBangla
              ? `${data.tciCertificateInfoPayload.certificateNameBangla} (${data.tciCertificateInfoPayload.durationBangla} ঘন্টা)`
              : data.tciCertificateInfoPayload.certificateNameBangla,
            style: 'courseTitleBN',
          },
          {
            text: '[বাংলাদেশ ন্যাশনাল কোয়ালিফিকেশন ফ্রেমওয়ার্ক (বিএনকিউএফ) এর আওতায়]',
            style: 'bnqfHeaderBN',
          },
          {
            text: '',
            style: 'labelIsAwardedToBN',
          },
          {
            text: data.tciCertificateInfoPayload.participantNameBangla,
            style: 'participantNameBN',
          },
          {
            text: [
              ` পিতা: `,
              {
                text: data.tciCertificateInfoPayload.fatherNameBangla,
                style: 'fatherMotherNidDynamicValueBN',
              },
              `, মাতা: `,
              {
                text: data.tciCertificateInfoPayload.motherNameBangla,
                style: 'fatherMotherNidDynamicValueBN',
              },
              `, জাতীয় পরিচয়পত্র / জন্ম নিবন্ধন নম্বর: `,
              {
                text:
                  data.tciCertificateInfoPayload.nidBangla || 'Not Provided',
                style: 'fatherMotherNidDynamicValueBN',
              },
              `-কে নিম্নোক্ত কম্পিটেন্সি ইউনিটসমূহ সফলভাবে সম্পন্ন করায়, জাতীয় দক্ষতা সনদ প্রদান করা হলো:`,
            ],
            style: 'participantDetailsBN',
          },

          {
            stack: data.tciCertificateInfoPayload.competencyList
              ? data.tciCertificateInfoPayload.competencyList
                  .split('\n')
                  .filter((item: string) => item.trim() !== '')
                  .sort((a: string, b: any) => a.localeCompare(b))
                  .map((item: string) => ({
                    columns: [
                      {
                        image: checkIconBase64,
                        width: 8,
                        margin: [0, -4, 5, 0],
                      },
                      {
                        text: item,
                        style: 'competencyListBN',
                      },
                    ],
                    columnGap: 5,
                    margin: [0, 2, 2, 2],
                  }))
              : [],
            margin: [30, 15, 0, 10],
          },
          {
            absolutePosition: { x: 30, y: 720 },
            columns: [
              {
                stack: [
                  {
                    table: {
                      widths: ['auto', 'auto'],
                      body: [
                        [
                          {
                            text: 'ক্রমিক নম্বর',
                            style: 'footerLeftStaticBN',
                          },
                          {
                            text: `: ${data.tciCertificateInfoPayload.serialNo}`,
                            style: 'footerLeftDynamic',
                          },
                        ],
                        [
                          {
                            text: 'রেজিস্ট্রেশন নম্বর',
                            style: 'footerLeftStaticBN',
                          },
                          {
                            text: `: ${data.tciCertificateInfoPayload.registrationNo}`,
                            style: 'footerLeftDynamic',
                          },
                        ],
                        [
                          {
                            text: 'ফলাফল প্রকাশের তারিখ',
                            style: 'footerLeftStaticBN',
                          },
                          {
                            text: `: ${data.tciCertificateInfoPayload.resultPublishedOnBangla}`,
                            style: 'footerLeftDynamicBN',
                          },
                        ],
                        [
                          {
                            text: 'মেয়াদোত্তীর্ণের তারিখ',
                            style: 'footerLeftStaticBN',
                          },
                          {
                            text: `: ${data.tciCertificateInfoPayload.validUntilBangla}`,
                            style: 'footerLeftDynamicBN',
                          },
                        ],
                      ],
                    },
                    layout: 'noBorders',
                  },
                ],
                width: '48%',
              },

              {
                image: `data:image/png;base64,${data.imageStringQR}`,
                width: 80,
                alignment: 'center',
                margin: [10, -9, 10, 0],
              },

              {
                width: '35%',
                stack: [
                  {
                    image: chairmanSignatureBase64,
                    width: 80,
                    height: 30,
                    alignment: 'center',
                    margin: [0, 0, 0, 5],
                  },
                  {
                    text: data.tciCertificateInfoPayload.chairmanBanglaName,
                    style: 'chairmanNameBN',
                  },
                  {
                    text: data.tciCertificateInfoPayload
                      .chairmanBanglaDesignation,
                    style: 'chairmanTextBN',
                  },
                ],
              },
            ],
            margin: [0, 10, 0, 0], // Adjust spacing
          },
        ],

        images: {
          bgImage: bgImageBase64,
          checkIcon: checkIconBase64,
          chairmanSignature: chairmanSignatureBase64,
        },

        styles: {
          //English
          header: {
            fontSize: 17,
            alignment: 'center',
            margin: [0, 114, 0, 10],
          },
          subheader: {
            fontSize: 12,
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 10],
          },
          subheaderGreen: {
            fontSize: 29,
            font: 'Calibri',
            bold: true,
            alignment: 'center',
            color: 'green',
            margin: [0, -3, 0, 10],
          },
          certificateTitle: {
            fontSize: 25,
            font: 'Calibri',
            bold: true,
            alignment: 'center',
            margin: [0, 20, 0, 0],
          },
          labelOn: {
            fontSize: 12,
            font: 'Carattere',
            italics: true,
            alignment: 'center',
            margin: [0, 5, 0, 0],
          },
          bnqfHeader: {
            fontSize: 12,
            font: 'Roboto',
            alignment: 'center',
            margin: [0, 5, 0, 0],
          },
          labelIsAwardedTo: {
            fontSize: 12,
            font: 'Carattere',
            italics: true,
            alignment: 'center',
            margin: [0, 23, 0, 0],
          },
          courseTitle: {
            fontSize: 16,
            alignment: 'center',
            margin: [0, 5, 0, 0],
          },
          participantName: {
            fontSize: 25,
            // font: 'OldEnglishTexTmt',
            bold: true,
            alignment: 'center',
            margin: [0, 5, 0, 10],
          },
          fatherMotherNidDynamicValue: {
            // font: 'OldEnglishTexTmt',
            // bold: true,
          },
          participantDetails: {
            fontSize: 11,
            alignment: 'center',
            margin: [10, 0, 10, 0],
            lineHeight: 1.5,
          },
          competencyListEN: {
            font: 'Roboto',
            italics: true,
            fontSize: 10,
            lineHeight: 1.2,
            margin: [0, -2, 0, 0],
          },
          footerLeftStatic: {
            fontSize: 11,
            alignment: 'left',
            font: 'Carattere',
            bold: true,
            margin: [25, 0, -7, 0],
          },
          footerLeftDynamic: { fontSize: 9, alignment: 'left', italics: true },
          chairmanNameEN: {
            fontSize: 11,
            alignment: 'center',
            font: 'Carattere',
            bold: true,
            margin: [0, 2, 0, 2],
          },
          chairmanTextEN: {
            fontSize: 12,
            alignment: 'center',
            font: 'Carattere',
            bold: true,
            margin: [0, 0, 0, 0],
          },

          //Bangla
          headerBN: {
            font: 'NikoshBAN',
            fontSize: 28,
            bold: true,
            alignment: 'center',
            margin: [0, 114, 0, 10],
          },
          subheaderBN: {
            font: 'NikoshBAN',
            fontSize: 22,
            bold: true,
            alignment: 'center',
            margin: [0, -10, 0, 10],
          },
          subheaderGreenBN: {
            font: 'NikoshBAN',
            fontSize: 30,
            bold: true,
            alignment: 'center',
            color: 'green',
            margin: [0, -12, 0, 10],
          },
          certificateTitleBN: {
            font: 'NikoshBAN',
            fontSize: 28,
            bold: true,
            alignment: 'center',
            margin: [0, 20, 0, 0],
          },
          labelOnBN: {
            font: 'NikoshBAN',
            fontSize: 12,
            italics: true,
            bold: true,
            alignment: 'center',
            margin: [0, 5, 0, 0],
          },
          bnqfHeaderBN: {
            fontSize: 12,
            font: 'NikoshBAN',
            alignment: 'center',
            margin: [0, 5, 0, 0],
          },
          labelIsAwardedToBN: {
            font: 'NikoshBAN',
            fontSize: 12,
            italics: true,
            bold: true,
            alignment: 'center',
            margin: [0, 23, 0, 0],
          },
          courseTitleBN: {
            font: 'NikoshBAN',
            fontSize: 23,
            alignment: 'center',
            margin: [0, -5, 0, 0],
          },
          participantNameBN: {
            font: 'NikoshBAN',
            fontSize: 20,
            bold: true,
            alignment: 'center',
            margin: [0, 5, 0, 10],
          },
          fatherMotherNidDynamicValueBN: {
            font: 'NikoshBAN',
            italics: true,
            //bold: true,
          },
          participantDetailsBN: {
            font: 'NikoshBAN',
            fontSize: 12,
            alignment: 'center',
            margin: [10, 0, 10, 0],
            lineHeight: 1.5,
          },
          competencyListBN: {
            font: 'Roboto',
            italics: true,
            fontSize: 10,
            lineHeight: 1.5,
            margin: [0, -6, 0, 0],
          },
          footerLeftStaticBN: {
            font: 'NikoshBAN',
            fontSize: 11,
            alignment: 'left',
            bold: true,
            margin: [25, 0, -7, 0],
          },
          footerLeftDynamicBN: {
            font: 'NikoshBAN',
            fontSize: 9,
            alignment: 'left',
            italics: true,
          },
          chairmanNameBN: {
            font: 'NikoshBAN',
            fontSize: 11,
            alignment: 'center',
            bold: true,
            margin: [0, 2, 0, 2],
          },
          chairmanTextBN: {
            font: 'NikoshBAN',
            fontSize: 12,
            alignment: 'center',
            bold: true,
            margin: [0, 0, 0, 0],
          },
        },
      };

      pdfMake
        .createPdf(documentDefinition)
        .download(
          `Certificate_${data.tciCertificateInfoPayload.participantName}.pdf`
        );
    } catch (error) {
      console.error('Error loading images:', error);
    }
  }

  async onCertificateDownloadREG(data: any) {
    try {
      const bgImageBase64 = await this.getBase64ImageFromURL(
        '/assets/certificate/new_certificate_files_by_pdf_make/bg.jpg'
      );
      const checkIconBase64 = await this.getBase64ImageFromURL(
        '/assets/certificate/new_certificate_files_by_pdf_make/green-check-mark.jpeg'
      );

      let fileUrl = data.chairmanSignatureFilePath;
      let chairmanSignatureBase64 = await this.getChairmanImageBase64(fileUrl);

      await this.loadFontToVFS('/assets/fonts/NikoshBAN.ttf', 'NikoshBAN');
      await this.loadFontToVFS(
        '/assets/fonts/Carattere/Carattere-Regular.ttf',
        'Carattere-Regular'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Edwardian-Script/edwardianscriptitc.ttf',
        'edwardianscriptitc'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Edwardian-Script/edwardian-script-itc-bold.ttf',
        'edwardianscriptitcb'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Old-English-Text-MT/oldenglishtextmt.ttf',
        'oldenglishtextmt'
      );

      await this.loadFontToVFS(
        '/assets/fonts/Calibri/calibri-bold-italic.ttf',
        'calibri-bold-italic'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Calibri/calibri-bold.ttf',
        'calibri-bold'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Calibri/calibri-italic.ttf',
        'calibri-italic'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Calibri/calibri-regular.ttf',
        'calibri-regular'
      );

      (pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
      (pdfMake as any).fonts = {
        NikoshBAN: {
          normal: 'NikoshBAN.ttf',
          bold: 'NikoshBAN.ttf',
          italics: 'NikoshBAN.ttf',
          bolditalics: 'NikoshBAN.ttf',
        },
        Roboto: {
          normal: 'Roboto-Regular.ttf',
          bold: 'Roboto-Medium.ttf',
          italics: 'Roboto-Italic.ttf',
          bolditalics: 'Roboto-MediumItalic.ttf',
        },
        EdwardianScriptItc: {
          normal: 'edwardianscriptitc.ttf',
          bold: 'edwardianscriptitcb.ttf',
          italics: 'edwardianscriptitc.ttf',
          bolditalics: 'edwardianscriptitc.ttf',
        },
        Carattere: {
          normal: 'Carattere-Regular.ttf',
          bold: 'Carattere-Regular.ttf',
          italics: 'Carattere-Regular.ttf',
          bolditalics: 'Carattere-Regular.ttf',
        },
        OldEnglishTexTmt: {
          normal: 'oldenglishtextmt.ttf',
          bold: 'oldenglishtextmt.ttf',
          italics: 'oldenglishtextmt.ttf',
          bolditalics: 'oldenglishtextmt.ttf',
        },
        Calibri: {
          normal: 'calibri-regular.ttf',
          bold: 'calibri-bold.ttf',
          italics: 'calibri-italic.ttf',
          bolditalics: 'calibri-bold-italic.ttf',
        },
      };

      const documentDefinition: any = {
        pageSize: 'A4',
        pageMargins: [40, 40, 40, 40],

        background: [
          {
            image: 'bgImage',
            width: 595,
            height: 842,
            absolutePosition: { x: 0, y: 0 },
          },
        ],

        content: [
          {
            text: 'Government of the People’s Republic of Bangladesh',
            style: 'header',
          },
          {
            text: data.officeNameEnglish,
            style: 'subheaderGreen',
          },
          {
            text: 'NATIONAL SKILLS DEVELOPMENT AUTHORITY (NSDA)',
            style: 'subheader',
          },
          {
            text:
              data.isCompetent == true
                ? 'National Skills Certificate'
                : 'Statement of Achievement',
            style: 'certificateTitle',
          },
          {
            text: 'on',
            style: 'labelOn',
          },
          {
            text: data.duration
              ? `${data.certificateName} (${data.duration} hours)`
              : data.certificateName,
            style: 'courseTitle',
          },
          {
            text: '[Under the Bangladesh National Qualification Framework (BNQF)]',
            style: 'bnqfHeader',
          },
          {
            text: 'is awarded to',
            style: 'labelIsAwardedTo',
          },
          {
            text: data.participantName,
            style: 'participantName',
          },

          {
            text: [
              `Father's Name: `,
              {
                text: data.fatherNameEnglish,
                style: 'fatherMotherNidDynamicValue',
              },
              `, Mother's Name: `,
              {
                text: data.motherNameEnglish,
                style: 'fatherMotherNidDynamicValue',
              },
              `, National ID/Birth Registration No: `,
              {
                text: data.nidEnglish || 'Not Provided',
                style: 'fatherMotherNidDynamicValue',
              },
              ` for successfully completing the requirements of the following units of competency:`,
            ],
            style: 'participantDetails',
          },

          {
            stack: data.competencyList
              ? data.competencyList
                  .split('\n')
                  .filter((item: string) => item.trim() !== '')
                  .sort((a: string, b: any) => a.localeCompare(b))
                  .map((item: string) => ({
                    columns: [
                      {
                        image: checkIconBase64,
                        width: 8,
                        margin: [0, 0, 5, 0],
                      },
                      {
                        text: item,
                        style: 'competencyListEN',
                      },
                    ],
                    columnGap: 5,
                    margin: [0, 2, 2, 2],
                  }))
              : [],
            margin: [30, 15, 0, 10],
          },
          {
            absolutePosition: { x: 30, y: 720 },
            columns: [
              {
                stack: [
                  {
                    table: {
                      widths: ['auto', 'auto'],
                      body: [
                        [
                          {
                            text: 'Serial No.',
                            style: 'footerLeftStatic',
                          },
                          {
                            text: `: ${data.serialNo}`,
                            style: 'footerLeftDynamic',
                          },
                        ],
                        [
                          {
                            text: 'Registration No.',
                            style: 'footerLeftStatic',
                          },
                          {
                            text: `: ${data.registrationNo}`,
                            style: 'footerLeftDynamic',
                          },
                        ],
                        [
                          {
                            text: 'Result Published On',
                            style: 'footerLeftStatic',
                          },
                          {
                            text: `: ${data.resultPublishedOn}`,
                            style: 'footerLeftDynamic',
                          },
                        ],
                        [
                          {
                            text: 'Valid until',
                            style: 'footerLeftStatic',
                          },
                          {
                            text: `: ${data.validUntil}`,
                            style: 'footerLeftDynamic',
                          },
                        ],
                      ],
                    },
                    layout: 'noBorders',
                  },
                ],
                width: '48%',
              },

              {
                image: `data:image/png;base64,${data.imageStringQR}`,
                width: 80,
                alignment: 'center',
                margin: [10, -9, 10, 0],
              },

              {
                width: '35%',
                stack: [
                  {
                    image: chairmanSignatureBase64,
                    width: 80,
                    height: 30,
                    alignment: 'center',
                    margin: [0, 0, 0, 5],
                  },
                  {
                    text: data.chairmanEnglishName,
                    style: 'chairmanNameEN',
                  },
                  {
                    text: data.chairmanEnglishDesignation,
                    style: 'chairmanTextEN',
                  },
                ],
              },
            ],
            margin: [0, 10, 0, 0], // Adjust spacing
          },

          // Second Page: Bangla Content
          { text: '', pageBreak: 'before' }, // Creates a new page
          {
            text: 'গণপ্রজাতন্ত্রী বাংলাদেশ সরকার',
            style: 'headerBN',
          },
          {
            text: data.officeNameBangla,
            style: 'subheaderGreenBN',
          },
          {
            text: 'জাতীয় দক্ষতা উন্নয়ন কর্তৃপক্ষ (এনএসডিএ)',
            style: 'subheaderBN',
          },
          {
            text:
              data.isCompetent == true
                ? 'জাতীয় দক্ষতা সনদ'
                : 'স্টেটমেন্ট অব অ্যাচিভমেন্ট',
            style: 'certificateTitleBN',
          },
          {
            text: '',
            style: 'labelOnBN',
          },
          {
            text: data.durationBangla
              ? `${data.certificateNameBangla} (${data.durationBangla} ঘন্টা)`
              : data.certificateNameBangla,
            style: 'courseTitleBN',
          },
          {
            text: '[বাংলাদেশ ন্যাশনাল কোয়ালিফিকেশন ফ্রেমওয়ার্ক (বিএনকিউএফ) এর আওতায়]',
            style: 'bnqfHeaderBN',
          },
          {
            text: '',
            style: 'labelIsAwardedToBN',
          },
          {
            text: data.participantNameBangla,
            style: 'participantNameBN',
          },

          {
            text: [
              ` পিতা: `,
              {
                text: data.fatherNameBangla,
                style: 'fatherMotherNidDynamicValueBN',
              },
              `, মাতা: `,
              {
                text: data.motherNameBangla,
                style: 'fatherMotherNidDynamicValueBN',
              },
              `, জাতীয় পরিচয়পত্র / জন্ম নিবন্ধন নম্বর: `,
              {
                text: data.nidBangla || 'Not Provided',
                style: 'fatherMotherNidDynamicValueBN',
              },
              `-কে নিম্নোক্ত কম্পিটেন্সি ইউনিটসমূহ সফলভাবে সম্পন্ন করায়, জাতীয় দক্ষতা সনদ প্রদান করা হলো:`,
            ],
            style: 'participantDetailsBN',
          },

          {
            stack: data.competencyList
              ? data.competencyList
                  .split('\n')
                  .filter((item: string) => item.trim() !== '')
                  .sort((a: string, b: any) => a.localeCompare(b))
                  .map((item: string) => ({
                    columns: [
                      {
                        image: checkIconBase64,
                        width: 8,
                        margin: [0, -4, 5, 0],
                      },
                      {
                        text: item,
                        style: 'competencyListBN',
                      },
                    ],
                    columnGap: 5,
                    margin: [0, 2, 2, 2],
                  }))
              : [],
            margin: [30, 15, 0, 10],
          },
          {
            absolutePosition: { x: 30, y: 720 },
            columns: [
              {
                stack: [
                  {
                    table: {
                      widths: ['auto', 'auto'],
                      body: [
                        [
                          {
                            text: 'ক্রমিক নম্বর',
                            style: 'footerLeftStaticBN',
                          },
                          {
                            text: `: ${data.serialNo}`,
                            style: 'footerLeftDynamic',
                          },
                        ],
                        [
                          {
                            text: 'রেজিস্ট্রেশন নম্বর',
                            style: 'footerLeftStaticBN',
                          },
                          {
                            text: `: ${data.registrationNo}`,
                            style: 'footerLeftDynamic',
                          },
                        ],
                        [
                          {
                            text: 'ফলাফল প্রকাশের তারিখ',
                            style: 'footerLeftStaticBN',
                          },
                          {
                            text: `: ${data.resultPublishedOnBangla}`,
                            style: 'footerLeftDynamicBN',
                          },
                        ],
                        [
                          {
                            text: 'মেয়াদোত্তীর্ণের তারিখ',
                            style: 'footerLeftStaticBN',
                          },
                          {
                            text: `: ${data.validUntilBangla}`,
                            style: 'footerLeftDynamicBN',
                          },
                        ],
                      ],
                    },
                    layout: 'noBorders',
                  },
                ],
                width: '48%',
              },

              {
                image: `data:image/png;base64,${data.imageStringQR}`,
                width: 80,
                alignment: 'center',
                margin: [10, -9, 10, 0],
              },

              {
                width: '35%',
                stack: [
                  {
                    image: chairmanSignatureBase64,
                    width: 80,
                    height: 30,
                    alignment: 'center',
                    margin: [0, 0, 0, 5],
                  },
                  {
                    text: data.chairmanBanglaName,
                    style: 'chairmanNameBN',
                  },
                  {
                    text: data.chairmanBanglaDesignation,
                    style: 'chairmanTextBN',
                  },
                ],
              },
            ],
            margin: [0, 10, 0, 0], // Adjust spacing
          },
        ],

        images: {
          bgImage: bgImageBase64,
          checkIcon: checkIconBase64,
          chairmanSignature: chairmanSignatureBase64,
        },

        styles: {
          //English
          header: {
            fontSize: 17,
            alignment: 'center',
            margin: [0, 114, 0, 10],
          },
          subheader: {
            fontSize: 12,
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 10],
          },
          subheaderGreen: {
            fontSize: 29,
            font: 'Calibri',
            bold: true,
            alignment: 'center',
            color: 'green',
            margin: [0, -3, 0, 10],
          },
          certificateTitle: {
            fontSize: 25,
            font: 'Calibri',
            bold: true,
            alignment: 'center',
            margin: [0, 20, 0, 0],
          },
          labelOn: {
            fontSize: 12,
            font: 'Carattere',
            italics: true,
            alignment: 'center',
            margin: [0, 5, 0, 0],
          },
          bnqfHeader: {
            fontSize: 12,
            font: 'Roboto',
            alignment: 'center',
            margin: [0, 5, 0, 0],
          },
          labelIsAwardedTo: {
            fontSize: 12,
            font: 'Carattere',
            italics: true,
            alignment: 'center',
            margin: [0, 23, 0, 0],
          },
          courseTitle: {
            fontSize: 16,
            alignment: 'center',
            margin: [0, 5, 0, 0],
          },
          participantName: {
            fontSize: 25,
            // font: 'OldEnglishTexTmt',
            bold: true,
            alignment: 'center',
            margin: [0, 5, 0, 10],
          },
          fatherMotherNidDynamicValue: {
            // font: 'OldEnglishTexTmt',
            // italics: true,
            //bold: true,
          },
          participantDetails: {
            fontSize: 11,
            alignment: 'center',
            margin: [10, 0, 10, 0],
            lineHeight: 1.5,
          },
          competencyListEN: {
            font: 'Roboto',
            italics: true,
            fontSize: 10,
            lineHeight: 1.2,
            margin: [0, -2, 0, 0],
          },
          footerLeftStatic: {
            fontSize: 11,
            alignment: 'left',
            font: 'Carattere',
            bold: true,
            margin: [25, 0, -7, 0],
          },
          footerLeftDynamic: { fontSize: 9, alignment: 'left', italics: true },
          chairmanNameEN: {
            fontSize: 11,
            alignment: 'center',
            font: 'Carattere',
            bold: true,
            margin: [0, 2, 0, 2],
          },
          chairmanTextEN: {
            fontSize: 12,
            alignment: 'center',
            font: 'Carattere',
            bold: true,
            margin: [0, 0, 0, 0],
          },

          //Bangla
          headerBN: {
            font: 'NikoshBAN',
            fontSize: 28,
            bold: true,
            alignment: 'center',
            margin: [0, 114, 0, 10],
          },
          subheaderBN: {
            font: 'NikoshBAN',
            fontSize: 22,
            bold: true,
            alignment: 'center',
            margin: [0, -10, 0, 10],
          },
          subheaderGreenBN: {
            font: 'NikoshBAN',
            fontSize: 30,
            bold: true,
            alignment: 'center',
            color: 'green',
            margin: [0, -12, 0, 10],
          },
          certificateTitleBN: {
            font: 'NikoshBAN',
            fontSize: 28,
            bold: true,
            alignment: 'center',
            margin: [0, 20, 0, 0],
          },
          labelOnBN: {
            font: 'NikoshBAN',
            fontSize: 12,
            italics: true,
            bold: true,
            alignment: 'center',
            margin: [0, 5, 0, 0],
          },
          bnqfHeaderBN: {
            fontSize: 12,
            font: 'NikoshBAN',
            alignment: 'center',
            margin: [0, 5, 0, 0],
          },
          labelIsAwardedToBN: {
            font: 'NikoshBAN',
            fontSize: 12,
            italics: true,
            bold: true,
            alignment: 'center',
            margin: [0, 23, 0, 0],
          },
          courseTitleBN: {
            font: 'NikoshBAN',
            fontSize: 23,
            alignment: 'center',
            margin: [0, -5, 0, 0],
          },
          participantNameBN: {
            font: 'NikoshBAN',
            fontSize: 20,
            bold: true,
            alignment: 'center',
            margin: [0, 5, 0, 10],
          },
          fatherMotherNidDynamicValueBN: {
            font: 'NikoshBAN',
            italics: true,
            //bold: true,
          },
          participantDetailsBN: {
            font: 'NikoshBAN',
            fontSize: 12,
            alignment: 'center',
            margin: [10, 0, 10, 0],
            lineHeight: 1.5,
          },
          competencyListBN: {
            font: 'Roboto',
            italics: true,
            fontSize: 10,
            lineHeight: 1.5,
            margin: [0, -6, 0, 0],
          },
          footerLeftStaticBN: {
            font: 'NikoshBAN',
            fontSize: 11,
            alignment: 'left',
            bold: true,
            margin: [25, 0, -7, 0],
          },
          footerLeftDynamicBN: {
            font: 'NikoshBAN',
            fontSize: 9,
            alignment: 'left',
            italics: true,
          },
          chairmanNameBN: {
            font: 'NikoshBAN',
            fontSize: 11,
            alignment: 'center',
            bold: true,
            margin: [0, 2, 0, 2],
          },
          chairmanTextBN: {
            font: 'NikoshBAN',
            fontSize: 12,
            alignment: 'center',
            bold: true,
            margin: [0, 0, 0, 0],
          },
        },
      };

      pdfMake
        .createPdf(documentDefinition)
        .download(`Certificate_${data.participantName}.pdf`);
    } catch (error) {
      console.error('Error loading images:', error);
    }
  }

  async onCertificateDownloadRPL(data: any) {
    try {
      const bgImageBase64 = await this.getBase64ImageFromURL(
        '/assets/certificate/new_certificate_files_by_pdf_make/bg.jpg'
      );
      const checkIconBase64 = await this.getBase64ImageFromURL(
        '/assets/certificate/new_certificate_files_by_pdf_make/green-check-mark.jpeg'
      );

      let fileUrl = data.chairmanSignatureFilePath;
      let chairmanSignatureBase64 = await this.getChairmanImageBase64(fileUrl);

      await this.loadFontToVFS('/assets/fonts/NikoshBAN.ttf', 'NikoshBAN');
      await this.loadFontToVFS(
        '/assets/fonts/Carattere/Carattere-Regular.ttf',
        'Carattere-Regular'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Edwardian-Script/edwardianscriptitc.ttf',
        'edwardianscriptitc'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Edwardian-Script/edwardian-script-itc-bold.ttf',
        'edwardianscriptitcb'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Old-English-Text-MT/oldenglishtextmt.ttf',
        'oldenglishtextmt'
      );

      await this.loadFontToVFS(
        '/assets/fonts/Calibri/calibri-bold-italic.ttf',
        'calibri-bold-italic'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Calibri/calibri-bold.ttf',
        'calibri-bold'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Calibri/calibri-italic.ttf',
        'calibri-italic'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Calibri/calibri-regular.ttf',
        'calibri-regular'
      );

      (pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
      (pdfMake as any).fonts = {
        NikoshBAN: {
          normal: 'NikoshBAN.ttf',
          bold: 'NikoshBAN.ttf',
          italics: 'NikoshBAN.ttf',
          bolditalics: 'NikoshBAN.ttf',
        },
        Roboto: {
          normal: 'Roboto-Regular.ttf',
          bold: 'Roboto-Medium.ttf',
          italics: 'Roboto-Italic.ttf',
          bolditalics: 'Roboto-MediumItalic.ttf',
        },
        EdwardianScriptItc: {
          normal: 'edwardianscriptitc.ttf',
          bold: 'edwardianscriptitcb.ttf',
          italics: 'edwardianscriptitc.ttf',
          bolditalics: 'edwardianscriptitc.ttf',
        },
        Carattere: {
          normal: 'Carattere-Regular.ttf',
          bold: 'Carattere-Regular.ttf',
          italics: 'Carattere-Regular.ttf',
          bolditalics: 'Carattere-Regular.ttf',
        },
        OldEnglishTexTmt: {
          normal: 'oldenglishtextmt.ttf',
          bold: 'oldenglishtextmt.ttf',
          italics: 'oldenglishtextmt.ttf',
          bolditalics: 'oldenglishtextmt.ttf',
        },
        Calibri: {
          normal: 'calibri-regular.ttf',
          bold: 'calibri-bold.ttf',
          italics: 'calibri-italic.ttf',
          bolditalics: 'calibri-bold-italic.ttf',
        },
      };

      const documentDefinition: any = {
        pageSize: 'A4',
        pageMargins: [40, 40, 40, 40],

        background: [
          {
            image: 'bgImage',
            width: 595,
            height: 842,
            absolutePosition: { x: 0, y: 0 },
          },
        ],

        content: [
          {
            text: 'Government of the People’s Republic of Bangladesh',
            style: 'header',
          },
          {
            text: data.officeNameEnglish,
            style: 'subheaderGreen',
          },
          {
            text: 'NATIONAL SKILLS DEVELOPMENT AUTHORITY (NSDA)',
            style: 'subheader',
          },
          {
            text:
              data.isCompetent == true
                ? 'National Skills Certificate'
                : 'Statement of Achievement',
            style: 'certificateTitle',
          },
          {
            text: 'on',
            style: 'labelOn',
          },
          {
            text: data.duration
              ? `${data.certificateName}` //(${data.duration} hours)
              : data.certificateName,
            style: 'courseTitle',
          },
          {
            text: '[Under the Bangladesh National Qualification Framework (BNQF)]',
            style: 'bnqfHeader',
          },
          {
            text: 'is awarded to',
            style: 'labelIsAwardedTo',
          },
          {
            text: data.participantName,
            style: 'participantName',
          },

          {
            text: [
              `Father's Name: `,
              {
                text: data.fatherNameEnglish,
                style: 'fatherMotherNidDynamicValue',
              },
              `, Mother's Name: `,
              {
                text: data.motherNameEnglish,
                style: 'fatherMotherNidDynamicValue',
              },
              `, National ID/Birth Registration No: `,
              {
                text: data.nidEnglish || 'Not Provided',
                style: 'fatherMotherNidDynamicValue',
              },
              ` for successfully completing the requirements of the following units of competency:`,
            ],
            style: 'participantDetails',
          },

          {
            stack: data.competencyList
              ? data.competencyList
                  .split('\n')
                  .filter((item: string) => item.trim() !== '')
                  .sort((a: string, b: any) => a.localeCompare(b))
                  .map((item: string) => ({
                    columns: [
                      {
                        image: checkIconBase64,
                        width: 8,
                        margin: [0, 0, 5, 0],
                      },
                      {
                        text: item,
                        style: 'competencyListEN',
                      },
                    ],
                    columnGap: 5,
                    margin: [0, 2, 2, 2],
                  }))
              : [],
            margin: [30, 15, 0, 10],
          },
          {
            absolutePosition: { x: 30, y: 720 },
            columns: [
              {
                stack: [
                  {
                    table: {
                      widths: ['auto', 'auto'],
                      body: [
                        [
                          {
                            text: 'Serial No.',
                            style: 'footerLeftStatic',
                          },
                          {
                            text: `: ${data.serialNo}`,
                            style: 'footerLeftDynamic',
                          },
                        ],
                        [
                          {
                            text: 'Registration No.',
                            style: 'footerLeftStatic',
                          },
                          {
                            text: `: ${data.registrationNo}`,
                            style: 'footerLeftDynamic',
                          },
                        ],
                        [
                          {
                            text: 'Result Published On',
                            style: 'footerLeftStatic',
                          },
                          {
                            text: `: ${data.resultPublishedOn}`,
                            style: 'footerLeftDynamic',
                          },
                        ],
                        [
                          {
                            text: 'Valid until',
                            style: 'footerLeftStatic',
                          },
                          {
                            text: `: ${data.validUntil}`,
                            style: 'footerLeftDynamic',
                          },
                        ],
                      ],
                    },
                    layout: 'noBorders',
                  },
                ],
                width: '48%',
              },

              {
                image: `data:image/png;base64,${data.imageStringQR}`,
                width: 80,
                alignment: 'center',
                margin: [10, -9, 10, 0],
              },

              {
                width: '35%',
                stack: [
                  {
                    image: chairmanSignatureBase64,
                    width: 80,
                    height: 30,
                    alignment: 'center',
                    margin: [0, 0, 0, 5],
                  },
                  {
                    text: data.chairmanEnglishName,
                    style: 'chairmanNameEN',
                  },
                  {
                    text: data.chairmanEnglishDesignation,
                    style: 'chairmanTextEN',
                  },
                ],
              },
            ],
            margin: [0, 10, 0, 0], // Adjust spacing
          },

          // Second Page: Bangla Content
          { text: '', pageBreak: 'before' }, // Creates a new page
          {
            text: 'গণপ্রজাতন্ত্রী বাংলাদেশ সরকার',
            style: 'headerBN',
          },
          {
            text: data.officeNameBangla,
            style: 'subheaderGreenBN',
          },
          {
            text: 'জাতীয় দক্ষতা উন্নয়ন কর্তৃপক্ষ (এনএসডিএ)',
            style: 'subheaderBN',
          },
          {
            text:
              data.isCompetent == true
                ? 'জাতীয় দক্ষতা সনদ'
                : 'স্টেটমেন্ট অব অ্যাচিভমেন্ট',
            style: 'certificateTitleBN',
          },
          {
            text: '',
            style: 'labelOnBN',
          },
          {
            text: data.durationBangla
              ? `${data.certificateNameBangla}` //(${data.durationBangla} ঘন্টা)
              : data.certificateNameBangla,
            style: 'courseTitleBN',
          },
          {
            text: '[বাংলাদেশ ন্যাশনাল কোয়ালিফিকেশন ফ্রেমওয়ার্ক (বিএনকিউএফ) এর আওতায়]',
            style: 'bnqfHeaderBN',
          },
          {
            text: '',
            style: 'labelIsAwardedToBN',
          },
          {
            text: data.participantNameBangla,
            style: 'participantNameBN',
          },

          {
            text: [
              ` পিতা: `,
              {
                text: data.fatherNameBangla,
                style: 'fatherMotherNidDynamicValueBN',
              },
              `, মাতা: `,
              {
                text: data.motherNameBangla,
                style: 'fatherMotherNidDynamicValueBN',
              },
              `, জাতীয় পরিচয়পত্র / জন্ম নিবন্ধন নম্বর: `,
              {
                text: data.nidBangla || 'Not Provided',
                style: 'fatherMotherNidDynamicValueBN',
              },
              `-কে নিম্নোক্ত কম্পিটেন্সি ইউনিটসমূহ সফলভাবে সম্পন্ন করায়, জাতীয় দক্ষতা সনদ প্রদান করা হলো:`,
            ],
            style: 'participantDetailsBN',
          },

          {
            stack: data.competencyList
              ? data.competencyList
                  .split('\n')
                  .filter((item: string) => item.trim() !== '')
                  .sort((a: string, b: any) => a.localeCompare(b))
                  .map((item: string) => ({
                    columns: [
                      {
                        image: checkIconBase64,
                        width: 8,
                        margin: [0, -4, 5, 0],
                      },
                      {
                        text: item,
                        style: 'competencyListBN',
                      },
                    ],
                    columnGap: 5,
                    margin: [0, 2, 2, 2],
                  }))
              : [],
            margin: [30, 15, 0, 10],
          },
          {
            absolutePosition: { x: 30, y: 720 },
            columns: [
              {
                stack: [
                  {
                    table: {
                      widths: ['auto', 'auto'],
                      body: [
                        [
                          {
                            text: 'ক্রমিক নম্বর',
                            style: 'footerLeftStaticBN',
                          },
                          {
                            text: `: ${data.serialNo}`,
                            style: 'footerLeftDynamic',
                          },
                        ],
                        [
                          {
                            text: 'রেজিস্ট্রেশন নম্বর',
                            style: 'footerLeftStaticBN',
                          },
                          {
                            text: `: ${data.registrationNo}`,
                            style: 'footerLeftDynamic',
                          },
                        ],
                        [
                          {
                            text: 'ফলাফল প্রকাশের তারিখ',
                            style: 'footerLeftStaticBN',
                          },
                          {
                            text: `: ${data.resultPublishedOnBangla}`,
                            style: 'footerLeftDynamicBN',
                          },
                        ],
                        [
                          {
                            text: 'মেয়াদোত্তীর্ণের তারিখ',
                            style: 'footerLeftStaticBN',
                          },
                          {
                            text: `: ${data.validUntilBangla}`,
                            style: 'footerLeftDynamicBN',
                          },
                        ],
                      ],
                    },
                    layout: 'noBorders',
                  },
                ],
                width: '48%',
              },

              {
                image: `data:image/png;base64,${data.imageStringQR}`,
                width: 80,
                alignment: 'center',
                margin: [10, -9, 10, 0],
              },

              {
                width: '35%',
                stack: [
                  {
                    image: chairmanSignatureBase64,
                    width: 80,
                    height: 30,
                    alignment: 'center',
                    margin: [0, 0, 0, 5],
                  },
                  {
                    text: data.chairmanBanglaName,
                    style: 'chairmanNameBN',
                  },
                  {
                    text: data.chairmanBanglaDesignation,
                    style: 'chairmanTextBN',
                  },
                ],
              },
            ],
            margin: [0, 10, 0, 0], // Adjust spacing
          },
        ],

        images: {
          bgImage: bgImageBase64,
          checkIcon: checkIconBase64,
          chairmanSignature: chairmanSignatureBase64,
        },

        styles: {
          //English
          header: {
            fontSize: 17,
            alignment: 'center',
            margin: [0, 114, 0, 10],
          },
          subheader: {
            fontSize: 12,
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 10],
          },
          subheaderGreen: {
            fontSize: 29,
            font: 'Calibri',
            bold: true,
            alignment: 'center',
            color: 'green',
            margin: [0, -3, 0, 10],
          },
          certificateTitle: {
            fontSize: 25,
            font: 'Calibri',
            bold: true,
            alignment: 'center',
            margin: [0, 20, 0, 0],
          },
          labelOn: {
            fontSize: 12,
            font: 'Carattere',
            italics: true,
            alignment: 'center',
            margin: [0, 5, 0, 0],
          },
          bnqfHeader: {
            fontSize: 12,
            font: 'Roboto',
            alignment: 'center',
            margin: [0, 5, 0, 0],
          },
          labelIsAwardedTo: {
            fontSize: 12,
            font: 'Carattere',
            italics: true,
            alignment: 'center',
            margin: [0, 23, 0, 0],
          },
          courseTitle: {
            fontSize: 16,
            alignment: 'center',
            margin: [0, 5, 0, 0],
          },
          participantName: {
            fontSize: 25,
            // font: 'OldEnglishTexTmt',
            bold: true,
            alignment: 'center',
            margin: [0, 5, 0, 10],
          },
          fatherMotherNidDynamicValue: {
            // font: 'OldEnglishTexTmt',
            // italics: true,
            //bold: true,
          },
          participantDetails: {
            fontSize: 11,
            alignment: 'center',
            margin: [10, 0, 10, 0],
            lineHeight: 1.5,
          },
          competencyListEN: {
            font: 'Roboto',
            italics: true,
            fontSize: 10,
            lineHeight: 1.2,
            margin: [0, -2, 0, 0],
          },
          footerLeftStatic: {
            fontSize: 11,
            alignment: 'left',
            font: 'Carattere',
            bold: true,
            margin: [25, 0, -7, 0],
          },
          footerLeftDynamic: { fontSize: 9, alignment: 'left', italics: true },
          chairmanNameEN: {
            fontSize: 11,
            alignment: 'center',
            font: 'Carattere',
            bold: true,
            margin: [0, 2, 0, 2],
          },
          chairmanTextEN: {
            fontSize: 12,
            alignment: 'center',
            font: 'Carattere',
            bold: true,
            margin: [0, 0, 0, 0],
          },

          //Bangla
          headerBN: {
            font: 'NikoshBAN',
            fontSize: 28,
            bold: true,
            alignment: 'center',
            margin: [0, 114, 0, 10],
          },
          subheaderBN: {
            font: 'NikoshBAN',
            fontSize: 22,
            bold: true,
            alignment: 'center',
            margin: [0, -10, 0, 10],
          },
          subheaderGreenBN: {
            font: 'NikoshBAN',
            fontSize: 30,
            bold: true,
            alignment: 'center',
            color: 'green',
            margin: [0, -12, 0, 10],
          },
          certificateTitleBN: {
            font: 'NikoshBAN',
            fontSize: 28,
            bold: true,
            alignment: 'center',
            margin: [0, 20, 0, 0],
          },
          labelOnBN: {
            font: 'NikoshBAN',
            fontSize: 12,
            italics: true,
            bold: true,
            alignment: 'center',
            margin: [0, 5, 0, 0],
          },
          bnqfHeaderBN: {
            fontSize: 12,
            font: 'NikoshBAN',
            alignment: 'center',
            margin: [0, 5, 0, 0],
          },
          labelIsAwardedToBN: {
            font: 'NikoshBAN',
            fontSize: 12,
            italics: true,
            bold: true,
            alignment: 'center',
            margin: [0, 23, 0, 0],
          },
          courseTitleBN: {
            font: 'NikoshBAN',
            fontSize: 23,
            alignment: 'center',
            margin: [0, -5, 0, 0],
          },
          participantNameBN: {
            font: 'NikoshBAN',
            fontSize: 20,
            bold: true,
            alignment: 'center',
            margin: [0, 5, 0, 10],
          },
          fatherMotherNidDynamicValueBN: {
            font: 'NikoshBAN',
            italics: true,
            //bold: true,
          },
          participantDetailsBN: {
            font: 'NikoshBAN',
            fontSize: 12,
            alignment: 'center',
            margin: [10, 0, 10, 0],
            lineHeight: 1.5,
          },
          competencyListBN: {
            font: 'Roboto',
            italics: true,
            fontSize: 10,
            lineHeight: 1.5,
            margin: [0, -6, 0, 0],
          },
          footerLeftStaticBN: {
            font: 'NikoshBAN',
            fontSize: 11,
            alignment: 'left',
            bold: true,
            margin: [25, 0, -7, 0],
          },
          footerLeftDynamicBN: {
            font: 'NikoshBAN',
            fontSize: 9,
            alignment: 'left',
            italics: true,
          },
          chairmanNameBN: {
            font: 'NikoshBAN',
            fontSize: 11,
            alignment: 'center',
            bold: true,
            margin: [0, 2, 0, 2],
          },
          chairmanTextBN: {
            font: 'NikoshBAN',
            fontSize: 12,
            alignment: 'center',
            bold: true,
            margin: [0, 0, 0, 0],
          },
        },
      };

      pdfMake
        .createPdf(documentDefinition)
        .download(`Certificate_${data.participantName}.pdf`);
    } catch (error) {
      console.error('Error loading images:', error);
    }
  }

  async getChairmanImageBase64(fileUrl: string): Promise<string> {
    try {
      const response = await fetch(environment.fileServiceApiUrl + fileUrl);
      const blob = await response.blob();
      return await this.convertBlobToBase64(blob);
    } catch (error) {
      console.error('Error fetching image:', error);
      throw error;
    }
  }

  convertBlobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  }

  getBase64ImageFromURL(url: any) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute('crossOrigin', 'anonymous');

      img.onload = () => {
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx: any | null = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL('image/png');

        resolve(dataURL);
      };

      img.onerror = (error) => {
        reject(error);
      };

      img.src = url;
    });
  }

  async loadFontToVFS(fontUrl: string, fontName: string) {
    const response = await fetch(fontUrl);
    const fontBlob = await response.blob();
    const reader = new FileReader();

    return new Promise((resolve) => {
      reader.onloadend = () => {
        const base64Font = (reader.result as string).split(',')[1]; // Get the Base64 part
        (pdfMake as any).vfs[`${fontName}.ttf`] = base64Font; // Store font in vfs
        resolve(true);
      };
      reader.readAsDataURL(fontBlob);
    });
  }

  async onDownloadSTPCertificate(data: any) {
    try {
      const bgImageBase64 = await this.getBase64ImageFromURL(
        '/assets/certificate/new_certificate_files_by_pdf_make/bg_stp.jpg'
      );

      let fileUrl = data.chairmanSignatureFilePath;
      let chairmanSignatureBase64 = await this.getChairmanImageBase64(fileUrl);

      await this.loadFontToVFS('/assets/fonts/NikoshBAN.ttf', 'NikoshBAN');
      await this.loadFontToVFS(
        '/assets/fonts/Carattere/Carattere-Regular.ttf',
        'Carattere-Regular'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Century-Schoolbook/CENSCBK.ttf',
        'CENSCBK'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Century-Schoolbook/SCHLBKB.ttf',
        'SCHLBKB'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Edwardian-Script/edwardianscriptitc.ttf',
        'edwardianscriptitc'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Edwardian-Script/edwardian-script-itc-bold.ttf',
        'edwardianscriptitcb'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Old-English-Text-MT/oldenglishtextmt.ttf',
        'oldenglishtextmt'
      );

      await this.loadFontToVFS(
        '/assets/fonts/Calibri/calibri-bold-italic.ttf',
        'calibri-bold-italic'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Calibri/calibri-bold.ttf',
        'calibri-bold'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Calibri/calibri-italic.ttf',
        'calibri-italic'
      );
      await this.loadFontToVFS(
        '/assets/fonts/Calibri/calibri-regular.ttf',
        'calibri-regular'
      );

      (pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
      (pdfMake as any).fonts = {
        NikoshBAN: {
          normal: 'NikoshBAN.ttf',
          bold: 'NikoshBAN.ttf',
          italics: 'NikoshBAN.ttf',
          bolditalics: 'NikoshBAN.ttf',
        },
        Roboto: {
          normal: 'Roboto-Regular.ttf',
          bold: 'Roboto-Medium.ttf',
          italics: 'Roboto-Italic.ttf',
          bolditalics: 'Roboto-MediumItalic.ttf',
        },
        EdwardianScriptItc: {
          normal: 'edwardianscriptitc.ttf',
          bold: 'edwardianscriptitcb.ttf',
          italics: 'edwardianscriptitc.ttf',
          bolditalics: 'edwardianscriptitc.ttf',
        },
        Carattere: {
          normal: 'Carattere-Regular.ttf',
          bold: 'Carattere-Regular.ttf',
          italics: 'Carattere-Regular.ttf',
          bolditalics: 'Carattere-Regular.ttf',
        },
        CENSCBK: {
          normal: 'CENSCBK.ttf',
          bold: 'SCHLBKB.ttf',
          italics: 'CENSCBK.ttf',
          bolditalics: 'SCHLBKB.ttf',
        },
        OldEnglishTexTmt: {
          normal: 'oldenglishtextmt.ttf',
          bold: 'oldenglishtextmt.ttf',
          italics: 'oldenglishtextmt.ttf',
          bolditalics: 'oldenglishtextmt.ttf',
        },
        Calibri: {
          normal: 'calibri-regular.ttf',
          bold: 'calibri-bold.ttf',
          italics: 'calibri-italic.ttf',
          bolditalics: 'calibri-bold-italic.ttf',
        },
      };

      const documentDefinition: any = {
        pageSize: 'A4',
        pageMargins: [40, 40, 40, 40],

        background: [
          {
            image: 'bgImage',
            width: 595,
            height: 842,
            absolutePosition: { x: 0, y: 0 },
          },
        ],

        content: [
          {
            text: 'Government of the People’s Republic of Bangladesh',
            style: 'header',
          },
          {
            text: data.officeNameEnglish,
            style: 'subheaderGreen',
          },
          {
            text: 'NATIONAL SKILLS DEVELOPMENT AUTHORITY (NSDA)',
            style: 'subheader',
          },
          {
            text: 'Certificate of Registration',
            style: 'certificateTitle',
          },
          {
            text: data.stpName,
            style: 'stpName',
          },

          {
            text: 'is registered as a Skills Training Provider under section 16(1) of NSDA Act, 2018.',
            style: 'details',
          },
          {
            absolutePosition: { x: 30, y: 680 },
            columns: [
              {
                stack: [
                  {
                    table: {
                      widths: ['auto', 'auto'],
                      body: [
                        [
                          {
                            text: 'Registration No.',
                            style: 'footerLeftStatic',
                          },
                          {
                            text: `: ${data.registrationNo}`,
                            style: 'footerLeftDynamic',
                          },
                        ],
                        [
                          {
                            text: 'Issued on',
                            style: 'footerLeftStatic',
                          },
                          {
                            text: `: ${data.issuedOn}`,
                            style: 'footerLeftDynamic',
                          },
                        ],
                        [
                          {
                            text: 'Valid until',
                            style: 'footerLeftStatic',
                          },
                          {
                            text: `: ${data.validUntil}`,
                            style: 'footerLeftDynamic',
                          },
                        ],
                      ],
                    },
                    layout: 'noBorders',
                  },
                ],
                width: '48%',
              },

              {
                image: `data:image/png;base64,${data.qrImageString}`,
                width: 80,
                alignment: 'center',
                margin: [10, -20, 10, 0],
              },

              {
                width: '35%',
                stack: [
                  {
                    image: chairmanSignatureBase64,
                    width: 80,
                    height: 30,
                    alignment: 'center',
                    margin: [0, -15, 0, 5],
                  },
                  {
                    text: data.chairmanEnglishName,
                    style: 'chairmanNameEN',
                  },
                  {
                    text: data.chairmanEnglishDesignation,
                    style: 'chairmanTextEN',
                  },
                ],
              },
            ],
            margin: [0, 10, 0, 0], // Adjust spacing
          },

          // Second Page: Bangla Content
          { text: '', pageBreak: 'before' }, // Creates a new page
          {
            text: 'গণপ্রজাতন্ত্রী বাংলাদেশ সরকার',
            style: 'headerBN',
          },
          {
            text: data.officeNameBangla,
            style: 'subheaderGreenBN',
          },
          {
            text: 'জাতীয় দক্ষতা উন্নয়ন কর্তৃপক্ষ (এনএসডিএ)',
            style: 'subheaderBN',
          },
          {
            text: 'নিবন্ধন সনদ',
            style: 'certificateTitleBN',
          },
          {
            text: data.stpNameBangla,
            style: 'stpNameBN',
          },

          {
            text: 'জাতীয় দক্ষতা উন্নয়ন কর্তৃপক্ষ আইন, ২০১৮ এর অনুচ্ছেদ ১৬(১) অনুযায়ী দক্ষতা প্রশিক্ষণ প্রতিষ্ঠান হিসেবে নিবন্ধন প্রদান করা হলো।',
            style: 'detailsBN',
          },
          {
            absolutePosition: { x: 30, y: 680 },
            columns: [
              {
                stack: [
                  {
                    table: {
                      widths: ['auto', 'auto'],
                      body: [
                        [
                          {
                            text: 'নিবন্ধন নম্বর',
                            style: 'footerLeftStaticBN',
                          },
                          {
                            text: `: ${data.registrationNo}`,
                            style: 'footerLeftDynamic',
                          },
                        ],
                        [
                          {
                            text: 'ইস্যুর তারিখ',
                            style: 'footerLeftStaticBN',
                          },
                          {
                            text: `: ${data.issuedOn}`,
                            style: 'footerLeftDynamicBN',
                          },
                        ],
                        [
                          {
                            text: 'মেয়াদোত্তীর্ণের তারিখ',
                            style: 'footerLeftStaticBN',
                          },
                          {
                            text: `: ${data.validUntilBangla}`,
                            style: 'footerLeftDynamicBN',
                          },
                        ],
                      ],
                    },
                    layout: 'noBorders',
                  },
                ],
                width: '48%',
              },

              {
                image: `data:image/png;base64,${data.qrImageString}`,
                width: 80,
                alignment: 'center',
                margin: [10, -20, 10, 0],
              },

              {
                width: '35%',
                stack: [
                  {
                    image: chairmanSignatureBase64,
                    width: 80,
                    height: 30,
                    alignment: 'center',
                    margin: [0, -15, 0, 5],
                  },
                  {
                    text: data.chairmanBanglaName,
                    style: 'chairmanNameBN',
                  },
                  {
                    text: data.chairmanBanglaDesignation,
                    style: 'chairmanTextBN',
                  },
                ],
              },
            ],
            margin: [0, 10, 0, 0], // Adjust spacing
          },
        ],

        images: {
          bgImage: bgImageBase64,
          chairmanSignature: chairmanSignatureBase64,
        },

        styles: {
          //English
          header: {
            fontSize: 17,
            alignment: 'center',
            margin: [0, 140, 0, 10],
          },
          subheader: {
            fontSize: 12,
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 0],
          },
          subheaderGreen: {
            fontSize: 29,
            font: 'Calibri',
            bold: true,
            alignment: 'center',
            color: 'green',
            margin: [0, -3, 0, 10],
          },
          certificateTitle: {
            fontSize: 25,
            font: 'Calibri',
            bold: true,
            alignment: 'center',
            margin: [0, 80, 0, 0],
          },
          stpName: {
            fontSize: 25,
            font: 'Roboto',
            bold: true,
            alignment: 'center',
            margin: [0, 45, 0, 10],
          },
          details: {
            font: 'CENSCBK',
            fontSize: 18,
            alignment: 'center',
            margin: [50, 0, 50, 0],
            lineHeight: 1.5,
          },
          footerLeftStatic: {
            fontSize: 11,
            alignment: 'left',
            font: 'Carattere',
            bold: true,
            margin: [40, 0, -7, 0],
          },
          footerLeftDynamic: { fontSize: 9, alignment: 'left', italics: true },
          chairmanNameEN: {
            fontSize: 11,
            alignment: 'center',
            font: 'Carattere',
            bold: true,
            margin: [0, 2, 0, 2],
          },
          chairmanTextEN: {
            fontSize: 12,
            alignment: 'center',
            font: 'Carattere',
            bold: true,
            margin: [0, 0, 0, 0],
          },

          //Bangla
          headerBN: {
            font: 'NikoshBAN',
            fontSize: 28,
            bold: true,
            alignment: 'center',
            margin: [0, 140, 0, 10],
          },
          subheaderBN: {
            font: 'NikoshBAN',
            fontSize: 22,
            bold: true,
            alignment: 'center',
            margin: [0, -10, 0, 0],
          },
          subheaderGreenBN: {
            font: 'NikoshBAN',
            fontSize: 30,
            bold: true,
            alignment: 'center',
            color: 'green',
            margin: [0, -12, 0, 10],
          },
          certificateTitleBN: {
            font: 'NikoshBAN',
            fontSize: 32,
            bold: true,
            alignment: 'center',
            margin: [0, 65, 0, 0],
          },
          stpNameBN: {
            font: 'NikoshBAN',
            fontSize: 28,
            bold: true,
            alignment: 'center',
            margin: [0, 45, 0, 10],
          },
          detailsBN: {
            font: 'NikoshBAN',
            fontSize: 17,
            alignment: 'center',
            margin: [50, 0, 50, 0],
            lineHeight: 1.5,
          },
          footerLeftStaticBN: {
            font: 'NikoshBAN',
            fontSize: 11,
            alignment: 'left',
            bold: true,
            margin: [40, 0, -7, 0],
          },
          footerLeftDynamicBN: {
            font: 'NikoshBAN',
            fontSize: 9,
            alignment: 'left',
            italics: true,
          },
          chairmanNameBN: {
            font: 'NikoshBAN',
            fontSize: 11,
            alignment: 'center',
            bold: true,
            margin: [0, 2, 0, 2],
          },
          chairmanTextBN: {
            font: 'NikoshBAN',
            fontSize: 12,
            alignment: 'center',
            bold: true,
            margin: [0, 0, 0, 0],
          },
        },
      };

      pdfMake
        .createPdf(documentDefinition)
        .download(`Certificate_${data.stpName}.pdf`);
    } catch (error) {
      console.error('Error loading images:', error);
    }
  }
}
